jQuery(document).ready(function ($) {
  var webyzeMultiProductColorsRunningCall=!1,webyzeMultiProductColorsQueuedCall=!1;window.webyzeMultiProductColorsLoad=function(){var $ = window.jQuery;function q(f,d){var c=f[0],a=f[1],b=f[2],e=f[3];c=h(c,a,b,e,d[0],7,-680876936);e=h(e,c,a,b,d[1],12,-389564586);b=h(b,e,c,a,d[2],17,606105819);a=h(a,b,e,c,d[3],22,-1044525330);c=h(c,a,b,e,d[4],7,-176418897);e=h(e,c,a,b,d[5],12,1200080426);b=h(b,e,c,a,d[6],17,-1473231341);a=h(a,b,e,c,d[7],22,-45705983);c=h(c,a,b,e,d[8],7,1770035416);e=h(e,c,a,b,d[9],12,-1958414417);b=h(b,e,c,a,d[10],17,-42063);a=h(a,b,e,c,d[11],22,-1990404162);c=h(c,a,b,e,d[12],7,1804603682);e=h(e,c,a,b,d[13],12,-40341101);b=h(b,e,c,a,d[14],17,-1502002290);a=h(a,b,e,c,d[15],22,1236535329);c=k(c,a,b,e,d[1],5,-165796510);e=k(e,c,a,b,d[6],9,-1069501632);b=k(b,e,c,a,d[11],14,643717713);a=k(a,b,e,c,d[0],20,-373897302);c=k(c,a,b,e,d[5],5,-701558691);e=k(e,c,a,b,d[10],9,38016083);b=k(b,e,c,a,d[15],14,-660478335);a=k(a,b,e,c,d[4],20,-405537848);c=k(c,a,b,e,d[9],5,568446438);e=k(e,c,a,b,d[14],9,-1019803690);b=k(b,e,c,a,d[3],14,-187363961);a=k(a,b,e,c,d[8],20,1163531501);c=k(c,a,b,e,d[13],5,-1444681467);e=k(e,c,a,b,d[2],9,-51403784);b=k(b,e,c,a,d[7],14,1735328473);a=k(a,b,e,c,d[12],20,-1926607734);c=g(a^b^e,c,a,d[5],4,-378558);e=g(c^a^b,e,c,d[8],11,-2022574463);b=g(e^c^a,b,e,d[11],16,1839030562);a=g(b^e^c,a,b,d[14],23,-35309556);c=g(a^b^e,c,a,d[1],4,-1530992060);e=g(c^a^b,e,c,d[4],11,1272893353);b=g(e^c^a,b,e,d[7],16,-155497632);a=g(b^e^c,a,b,d[10],23,-1094730640);c=g(a^b^e,c,a,d[13],4,681279174);e=g(c^a^b,e,c,d[0],11,-358537222);b=g(e^c^a,b,e,d[3],16,-722521979);a=g(b^e^c,a,b,d[6],23,76029189);c=g(a^b^e,c,a,d[9],4,-640364487);e=g(c^a^b,e,c,d[12],11,-421815835);b=g(e^c^a,b,e,d[15],16,530742520);a=g(b^e^c,a,b,d[2],23,-995338651);c=l(c,a,b,e,d[0],6,-198630844);e=l(e,c,a,b,d[7],10,1126891415);b=l(b,e,c,a,d[14],15,-1416354905);a=l(a,b,e,c,d[5],21,-57434055);c=l(c,a,b,e,d[12],6,1700485571);e=l(e,c,a,b,d[3],10,-1894986606);b=l(b,e,c,a,d[10],15,-1051523);a=l(a,b,e,c,d[1],21,-2054922799);c=l(c,a,b,e,d[8],6,1873313359);e=l(e,c,a,b,d[15],10,-30611744);b=l(b,e,c,a,d[6],15,-1560198380);a=l(a,b,e,c,d[13],21,1309151649);c=l(c,a,b,e,d[4],6,-145523070);e=l(e,c,a,b,d[11],10,-1120210379);b=l(b,e,c,a,d[2],15,718787259);a=l(a,b,e,c,d[9],21,-343485551);f[0]=c+f[0]&4294967295;f[1]=a+f[1]&4294967295;f[2]=b+f[2]&4294967295;f[3]=e+f[3]&4294967295}function g(f,d,c,a,b,e){d=(d+f&4294967295)+(a+e&4294967295)&4294967295;return(d<<b|d>>>32-b)+c&4294967295}function h(f,d,c,a,b,e,m){return g(d&c|~d&a,f,d,b,e,m)}function k(f,d,c,a,b,e,m){return g(d&a|c&~a,f,d,b,e,m)}function l(f,d,c,a,b,e,m){return g(c^(d|~a),f,d,b,e,m)}function r(f){txt="";var d=f.length,c=[1732584193,-271733879,-1732584194,271733878],a;for(a=64;a<=f.length;a+=64){var b,e=f.substring(a-64,a),m=[];for(b=0;64>b;b+=4)m[b>>2]=e.charCodeAt(b)+(e.charCodeAt(b+1)<<8)+(e.charCodeAt(b+2)<<16)+(e.charCodeAt(b+3)<<24);q(c,m)}f=f.substring(a-64);b=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(a=0;a<f.length;a++)b[a>>2]|=f.charCodeAt(a)<<(a%4<<3);b[a>>2]|=128<<(a%4<<3);if(55<a)for(q(c,b),a=0;16>a;a++)b[a]=0;b[14]=8*d;q(c,b);return c}function t(f){for(var d=0;d<f.length;d++){for(var c=d,a=f[d],b="",e=0;4>e;e++)b+=u[a>>8*e+4&15]+u[a>>8*e&15];f[c]=b}return f.join("")}var n=function(){var f={'"':"&quot;","&":"&amp;","<":"&lt;",">":"&gt;"};return function(d){return d.replace(/["&<>]/g,function(c){return f[c]})}}(),p=$(".webyze-multi-product-colors:not(.webyze-loaded)").map(function(){return $(this).attr("data-product-id")}).get();if(p&&0!=p.length)if(webyzeMultiProductColorsRunningCall)webyzeMultiProductColorsQueuedCall=!0;else{webyzeMultiProductColorsRunningCall=!0;webyzeMultiProductColorsQueuedCall=!1;var u="0123456789abcdef".split("");t(r("hello"));var v="shop="+Shopify.shop+p.map(function(f){return"&prodId[]="+f}).join("");$.ajax({method:"GET",url:"https://s-pc.webyze.com/ProductColors/productGroup-"+t(r(v))+"?"+v,dataType:"json"}).done(function(f){Array.isArray(f)&&(f=f.map(function(d){return JSON.parse(d)}),f.forEach(function(d){if(Array.isArray(d)){d.map(function(a){return a.id});var c="";d.forEach(function(a){c+='<span class="swatchProductColor swatchType_'+a.type+'" data-name="'+n(a.name)+'" data-handle="'+n(a.handle)+'" data-image="'+n(a.image)+'">';if(window.webyzeProductColors_useProdImage)c+="<div style=\"background-image: url('"+a.image.replace(/\.(png|jpg|jpeg|bmp)/,window.webyzeProductColors_prodImageLarge?"_large.$1":"_small.$1")+"');background-size: cover;\"></div>";else switch(a.type){case "two_colors":a.data=a.data.split("|");c+='<div><div style="background:'+a.data[0]+';"></div><div style="background:'+a.data[1]+';"></div></div>';break;case "image":c+="<div style=\"background-image: url('https://s-pc.webyze.com/ProductColors/uploads/"+a.data+"');\"></div>";break;default:c+='<div style="background:'+a.data+';"></div>'}c+='<span class="webyzeTooltip"><span></span><span class="innerText">'+n(a.name)+"</span><span></span></span></span>"});$(d.map(function(a){return'.webyze-multi-product-colors[data-product-id="'+a.id+'"]'}).join(", ")).addClass("webyze-loaded").html(c)}}),$(".webyze-multi-product-colors").find(".swatchProductColor").on("click",function(d){d.preventDefault();window.location.href="/products/"+$(this).data("handle")}).on("mouseenter",function(){var d=$(this).attr("data-image").replace(/\.(jpg|png|jpeg)/,"_large.$1");0===d.indexOf("https://")&&$(this).parent().parent().parent().find("img").attr("src",d).attr("srcset",d)}),$(p.map(function(d){return'.webyze-multi-product-colors[data-product-id="'+d+'"]'}).join(", ")).addClass("webyze-loaded"))}).fail(function(){}).always(function(){webyzeMultiProductColorsRunningCall=!1;webyzeMultiProductColorsQueuedCall&&window.webyzeMultiProductColorsLoad()})}};
  window.webyzeMultiProductColorsLoad && window.webyzeMultiProductColorsLoad();
  let cartPopupActive = false;
  let menuDrawerActive = false;
  let toggleFooterActive = false;
  let headerCartDrawerBound = false;

  function isCartDrawerMode() {
    return (window.themeSettings && window.themeSettings.cartType) === "drawer";
  }

  function updateCartDrawerScrollClass() {
    const body = document.querySelector("[data-cart-drawer-body]");
    const header = document.querySelector(".cart-drawer__header");
    const footer = document.querySelector("[data-cart-drawer-footer]");
    if (!body) return;
    // Class "scroll" when product list overflows available drawer height
    const canScroll = body.scrollHeight > body.clientHeight + 1;
    if (header) header.classList.toggle("scroll", canScroll);
    body.classList.remove("scroll");
    if (footer) footer.classList.toggle("scroll", canScroll);
  }

  function openCartDrawer() {
    const $drawer = $("#CartDrawer");
    if (!$drawer.length) return;
    resetCartDrawerSwipeTransform($drawer);
    $drawer.addClass("active").attr("aria-hidden", "false");
    $("html").addClass("cart-drawer-active");
    bindCartDrawerEvents();
    window.requestAnimationFrame(function () {
      updateCartDrawerScrollClass();
    });
  }

  function closeCartDrawer() {
    const $drawer = $("#CartDrawer");
    if (!$drawer.length) return;
    // Remove active first so CSS closed-state wins; then clear swipe inline styles.
    // Resetting transform while still .active snaps the panel back open.
    $drawer.removeClass("active").attr("aria-hidden", "true");
    $("html").removeClass("cart-drawer-active");
    resetCartDrawerSwipeTransform($drawer);
    const header = document.querySelector(".cart-drawer__header");
    const body = document.querySelector("[data-cart-drawer-body]");
    const footer = document.querySelector("[data-cart-drawer-footer]");
    if (header) header.classList.remove("scroll");
    if (body) body.classList.remove("scroll");
    if (footer) footer.classList.remove("scroll");
  }

  function getCartDrawerSwipePanel($drawer) {
    const $panel = $drawer.find(".cart-drawer__panel").first();
    return $panel.length ? $panel : $drawer;
  }

  function resetCartDrawerSwipeTransform($drawer) {
    const $panel = getCartDrawerSwipePanel($drawer);
    $panel.css({
      transform: "",
      transition: "",
      webkitTransform: "",
    });
  }

  function bindCartDrawerSwipe($drawer) {
    const ns = ".cartDrawerSwipe";
    const SWIPE_THRESHOLD = 50;
    const SWIPE_RATIO = 0.15;
    const DIRECTION_LOCK = 5;
    const drawerEl = $drawer.get(0);
    const panelEl = getCartDrawerSwipePanel($drawer).get(0);
    const bodyEl = drawerEl
      ? drawerEl.querySelector("[data-cart-drawer-body]")
      : null;
    // Listen on the panel so header, product list, and footer all swipe-close.
    const swipeRoot = panelEl || drawerEl;

    $drawer.off(ns);
    $(window).off("resize" + ns);
    if (drawerEl && drawerEl._cartDrawerSwipeCleanup) {
      drawerEl._cartDrawerSwipeCleanup();
      drawerEl._cartDrawerSwipeCleanup = null;
    }
    $drawer.removeData("cartDrawerSwipeBound");

    $(window).on("resize" + ns, function () {
      const shouldBeBound = isMobileViewport();
      const isBound = !!$drawer.data("cartDrawerSwipeBound");
      if (shouldBeBound === isBound) return;
      bindCartDrawerSwipe($drawer);
    });

    if (!isMobileViewport() || !drawerEl || !swipeRoot) {
      resetCartDrawerSwipeTransform($drawer);
      return;
    }

    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let dragging = false;
    let locked = null; // null | "x" | "y"
    let activePointerId = null;
    let $panel = null;
    let closing = false;
    let movedFar = false;
    let usingTouch = false;
    const touchActionTargets = [swipeRoot, bodyEl].filter(Boolean);

    function setSwipeTouchAction(value) {
      touchActionTargets.forEach(function (el) {
        el.style.touchAction = value;
      });
    }

    function setPanelX(x, withTransition) {
      if (!$panel || !$panel.length) return;
      const transform = "translate3d(" + x + "px, 0, 0)";
      $panel.css({
        transition: withTransition ? "transform 0.2s ease-out" : "none",
        transform: transform,
        webkitTransform: transform,
      });
    }

    function endGesture() {
      dragging = false;
      locked = null;
      activePointerId = null;
      currentX = 0;
      movedFar = false;
      usingTouch = false;
      setSwipeTouchAction("pan-y");
    }

    function finishSwipe() {
      if (closing) return;
      if (!dragging && currentX <= 0) {
        endGesture();
        return;
      }
      if (!$panel || !$panel.length) {
        $panel = getCartDrawerSwipePanel($drawer);
      }
      if (!$panel || !$panel.length) {
        endGesture();
        return;
      }

      const panelWidth = $panel.outerWidth() || $(window).innerWidth() || 1;
      const shouldClose =
        currentX >= SWIPE_THRESHOLD || currentX / panelWidth >= SWIPE_RATIO;

      if (shouldClose) {
        closing = true;
        // Close immediately so pointercancel / style resets can't snap it back open
        closeCartDrawer();
        closing = false;
        endGesture();
      } else {
        setPanelX(0, true);
        window.setTimeout(function () {
          resetCartDrawerSwipeTransform($drawer);
        }, 200);
        endGesture();
      }
    }

    function beginGesture(pointerId, clientX, clientY) {
      if (!isMobileViewport() || closing) return false;
      if (!$drawer.hasClass("active")) return false;
      if ($("#CartDrawerRemoveModal").hasClass("active")) return false;
      if (activePointerId !== null) return false;

      activePointerId = pointerId;
      startX = clientX;
      startY = clientY;
      currentX = 0;
      dragging = true;
      locked = null;
      movedFar = false;
      $panel = getCartDrawerSwipePanel($drawer);
      setPanelX(0, false);
      return true;
    }

    function moveGesture(pointerId, clientX, clientY, e) {
      if (!dragging || pointerId !== activePointerId) return;

      const deltaX = clientX - startX;
      const deltaY = clientY - startY;

      if (!locked) {
        if (
          Math.abs(deltaX) < DIRECTION_LOCK &&
          Math.abs(deltaY) < DIRECTION_LOCK
        ) {
          return;
        }
        locked = Math.abs(deltaX) > Math.abs(deltaY) ? "x" : "y";
        if (locked === "y") {
          // Vertical scroll on product list — release gesture so native scroll works
          dragging = false;
          activePointerId = null;
          locked = null;
          usingTouch = false;
          setSwipeTouchAction("pan-y");
          return;
        }
        // Horizontal close gesture — block scroll so product list can't cancel it
        setSwipeTouchAction("none");
        if (!usingTouch) {
          try {
            swipeRoot.setPointerCapture(pointerId);
          } catch (err) {
            /* ignore */
          }
        }
      }

      if (locked !== "x") return;

      currentX = Math.max(0, deltaX);
      if (currentX > 8) movedFar = true;
      setPanelX(currentX, false);

      if (e) {
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
      }
    }

    function onPointerDown(e) {
      // Touch is handled by touch* listeners — pointercancel on overflow body
      // otherwise kills swipe on the product list area.
      if (e.pointerType === "touch") return;
      if (e.pointerType === "mouse" && typeof e.button === "number" && e.button !== 0) {
        return;
      }
      usingTouch = false;
      beginGesture(e.pointerId, e.clientX, e.clientY);
    }

    function onPointerMove(e) {
      if (usingTouch || e.pointerType === "touch") return;
      moveGesture(e.pointerId, e.clientX, e.clientY, e);
    }

    function onPointerUp(e) {
      if (usingTouch || e.pointerType === "touch") return;
      if (e.pointerId !== activePointerId) return;
      try {
        if (swipeRoot.hasPointerCapture && swipeRoot.hasPointerCapture(e.pointerId)) {
          swipeRoot.releasePointerCapture(e.pointerId);
        }
      } catch (err) {
        /* ignore */
      }

      if (!dragging && !movedFar) {
        activePointerId = null;
        return;
      }
      finishSwipe();
    }

    function onPointerCancel(e) {
      if (usingTouch || e.pointerType === "touch") return;
      if (e.pointerId !== activePointerId) return;
      if (locked === "x" || currentX > 0 || movedFar) {
        finishSwipe();
        return;
      }
      resetCartDrawerSwipeTransform($drawer);
      endGesture();
    }

    function onClickCapture(e) {
      // After a horizontal swipe, suppress the synthetic click on links/buttons
      if (!movedFar) return;
      e.preventDefault();
      e.stopPropagation();
      movedFar = false;
    }

    // Primary path for mobile: touch events keep working on the scrollable
    // product list where PointerEvents get cancelled by overflow scrolling.
    function onTouchStart(e) {
      if (!e.touches || e.touches.length !== 1) return;
      const t = e.touches[0];
      usingTouch = true;
      beginGesture(1, t.clientX, t.clientY);
    }

    function onTouchMove(e) {
      if (!usingTouch) return;
      if (!e.touches || !e.touches.length) return;
      const t = e.touches[0];
      moveGesture(1, t.clientX, t.clientY, e);
    }

    function onTouchEnd() {
      if (!usingTouch) return;
      if (activePointerId !== 1) return;
      if (!dragging && !movedFar) {
        endGesture();
        return;
      }
      finishSwipe();
    }

    const listenerOpts = { passive: false };
    swipeRoot.addEventListener("pointerdown", onPointerDown, listenerOpts);
    swipeRoot.addEventListener("pointermove", onPointerMove, listenerOpts);
    swipeRoot.addEventListener("pointerup", onPointerUp, listenerOpts);
    swipeRoot.addEventListener("pointercancel", onPointerCancel, listenerOpts);
    swipeRoot.addEventListener("click", onClickCapture, true);
    swipeRoot.addEventListener("touchstart", onTouchStart, listenerOpts);
    swipeRoot.addEventListener("touchmove", onTouchMove, listenerOpts);
    swipeRoot.addEventListener("touchend", onTouchEnd, listenerOpts);
    swipeRoot.addEventListener("touchcancel", onTouchEnd, listenerOpts);
    setSwipeTouchAction("pan-y");

    drawerEl._cartDrawerSwipeCleanup = function () {
      swipeRoot.removeEventListener("pointerdown", onPointerDown, listenerOpts);
      swipeRoot.removeEventListener("pointermove", onPointerMove, listenerOpts);
      swipeRoot.removeEventListener("pointerup", onPointerUp, listenerOpts);
      swipeRoot.removeEventListener("pointercancel", onPointerCancel, listenerOpts);
      swipeRoot.removeEventListener("click", onClickCapture, true);
      swipeRoot.removeEventListener("touchstart", onTouchStart, listenerOpts);
      swipeRoot.removeEventListener("touchmove", onTouchMove, listenerOpts);
      swipeRoot.removeEventListener("touchend", onTouchEnd, listenerOpts);
      swipeRoot.removeEventListener("touchcancel", onTouchEnd, listenerOpts);
      touchActionTargets.forEach(function (el) {
        el.style.touchAction = "";
      });
    };

    $drawer.data("cartDrawerSwipeBound", true);
  }

  const CART_DRAWER_CLOSE_AFTER_CONTINUE_KEY = "r2bCloseCartDrawerOnShow";

  function isMobileViewport() {
    return $(window).innerWidth() < 769;
  }

  function markCloseCartDrawerAfterContinueShopping() {
    if (!isCartDrawerMode() || !isMobileViewport()) return;
    try {
      sessionStorage.setItem(CART_DRAWER_CLOSE_AFTER_CONTINUE_KEY, "1");
    } catch (err) {
      /* ignore */
    }
    closeCartDrawer();
  }

  function applyCloseCartDrawerAfterContinueShopping() {
    if (!isCartDrawerMode() || !isMobileViewport()) return;
    try {
      if (sessionStorage.getItem(CART_DRAWER_CLOSE_AFTER_CONTINUE_KEY) === "1") {
        sessionStorage.removeItem(CART_DRAWER_CLOSE_AFTER_CONTINUE_KEY);
        closeCartDrawer();
      }
    } catch (err) {
      /* ignore */
    }
  }

  function openHeaderCartDrawer(e) {
    e.preventDefault();
    openCartDrawer();
  }

  let pendingRemoveLineKey = null;
  let pendingRemoveLine = null;
  const cartLineUpdateQueues = {};
  // Serialize cart API calls so two BOGO deals cannot race and split lines.
  let cartApiQueue = Promise.resolve();
  let cartMutationGeneration = 0;

  function runCartApi(fn) {
    const gen = cartMutationGeneration;
    const next = cartApiQueue.then(
      function () {
        if (gen !== cartMutationGeneration) return null;
        return fn();
      },
      function () {
        if (gen !== cartMutationGeneration) return null;
        return fn();
      }
    );
    cartApiQueue = next.then(
      function () {},
      function () {}
    );
    return next;
  }

  function invalidateCartLineQueues(keys) {
    (keys || []).forEach(function (key) {
      if (!key) return;
      const queueId = getCartLineQueueId(key, null);
      if (!cartLineUpdateQueues[queueId]) return;
      cartLineUpdateQueues[queueId].pending = null;
      cartLineUpdateQueues[queueId].requestSeq += 1;
    });
  }

  function formatCartMoney(cents) {
    const format =
      (window.shop && window.shop.moneyFormat) ||
      (window.theme && window.theme.moneyFormat) ||
      "";
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    cents = Number(cents);
    if (isNaN(cents)) return "";

    // Fallback when moneyFormat is missing — keep € / locale decimals
    if (!format) {
      const currencyCode =
        (window.shop && window.shop.currencyCode) || "EUR";
      const currencySymbol =
        (window.shop && window.shop.currencySymbol) || "€";
      const currenciesUsingComma =
        "ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,UYU,VES,VND";
      const useComma = currenciesUsingComma.indexOf(currencyCode.trim()) !== -1;
      const amount = (cents / 100.0).toFixed(2);
      return (
        currencySymbol + (useComma ? amount.replace(".", ",") : amount)
      );
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatWithDelimiters = function (number, precision, thousands, decimal) {
      precision = typeof precision === "undefined" ? 2 : precision;
      thousands = typeof thousands === "undefined" ? "," : thousands;
      decimal = typeof decimal === "undefined" ? "." : decimal;

      if (isNaN(number) || number == null) return "0";

      number = (number / 100.0).toFixed(precision);
      const parts = number.split(".");
      const dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      const centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    };

    const match = format.match(placeholderRegex);
    if (!match || !match[1]) {
      const currencySymbol =
        (window.shop && window.shop.currencySymbol) || "€";
      return currencySymbol + String((cents / 100).toFixed(2));
    }

    let value = "";
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", "");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  function getCartLineQueueId(lineKey, lineNumber) {
    return lineKey || "line-" + String(lineNumber);
  }

  function resolveCartLineNumber(lineKey, lineNumber) {
    if (lineKey) {
      const $drawerItem = findCartDrawerItem(lineKey, null);
      if ($drawerItem.length) {
        const liveLine = parseInt($drawerItem.attr("data-line"), 10);
        if (!isNaN(liveLine) && liveLine > 0) return liveLine;
      }
      const $pageItem = findCartPageItem(lineKey, null);
      if ($pageItem.length) {
        const liveLine = parseInt($pageItem.attr("data-line"), 10);
        if (!isNaN(liveLine) && liveLine > 0) return liveLine;
      }
    }
    const parsed = parseInt(lineNumber, 10);
    return !isNaN(parsed) && parsed > 0 ? parsed : null;
  }

  function getOptimisticQuantity(lineKey, lineNumber) {
    const $drawerItem = findCartDrawerItem(lineKey, lineNumber);
    if ($drawerItem.length) {
      const qty = parseInt($drawerItem.find(".cart-drawer__qty-input").val(), 10);
      if (!isNaN(qty)) return qty;
    }
    const $pageItem = findCartPageItem(lineKey, lineNumber);
    if ($pageItem.length) {
      const qty = parseInt($pageItem.find(".r2b-cart__qty-input").val(), 10);
      if (!isNaN(qty)) return qty;
    }
    return null;
  }

  function getR2bBundleCartLevelAllocations(cartData) {
    const allocations = {};
    if (!cartData || !Array.isArray(cartData.items)) return allocations;

    let totalDiscount = Number(cartData.total_discount) || 0;
    if (
      !totalDiscount &&
      Number(cartData.original_total_price) > Number(cartData.total_price)
    ) {
      totalDiscount = Number(cartData.original_total_price) - Number(cartData.total_price);
    }
    if (totalDiscount <= 0) return allocations;

    let lineLevelDiscountTotal = 0;
    const eligible = [];
    let eligibleBaseTotal = 0;

    cartData.items.forEach(function (item) {
      const originalLine = Number(item.original_line_price);
      const finalLine = Number(item.final_line_price);
      const explicitLineDiscount = Number(item.line_level_total_discount);

      let lineDiscount = 0;
      if (!isNaN(originalLine) && !isNaN(finalLine) && originalLine > finalLine) {
        lineDiscount = originalLine - finalLine;
      }
      if (!isNaN(explicitLineDiscount) && explicitLineDiscount > lineDiscount) {
        lineDiscount = explicitLineDiscount;
      }
      lineLevelDiscountTotal += Math.max(lineDiscount, 0);

      const props = item.properties || {};
      const group = String(props._r2b_bundle_group || '').trim();
      const role = String(props._r2b_bundle_role || '').trim();
      if (!group || role !== 'addon') return;

      const qty = Math.max(Number(item.quantity) || 0, 0);
      let baseLine = !isNaN(finalLine) && finalLine >= 0
        ? finalLine
        : (Number(item.final_price) || Number(item.original_price) || 0) * qty;

      if (baseLine <= 0 || qty <= 0) return;
      eligible.push({ item: item, baseLine: baseLine, quantity: qty });
      eligibleBaseTotal += baseLine;
    });

    let remainingCartLevelDiscount = totalDiscount - lineLevelDiscountTotal;
    if (remainingCartLevelDiscount <= 0 || eligibleBaseTotal <= 0 || !eligible.length) {
      return allocations;
    }

    // Verdeel exact over de bundle-addons. De laatste regel krijgt het eventuele
    // afrondingsverschil zodat de som altijd gelijk blijft aan de cart-korting.
    let allocatedSoFar = 0;
    eligible.forEach(function (entry, index) {
      let lineAllocation;
      if (index === eligible.length - 1) {
        lineAllocation = Math.max(remainingCartLevelDiscount - allocatedSoFar, 0);
      } else {
        lineAllocation = Math.round(
          remainingCartLevelDiscount * (entry.baseLine / eligibleBaseTotal)
        );
        lineAllocation = Math.max(lineAllocation, 0);
        allocatedSoFar += lineAllocation;
      }

      const perUnit = entry.quantity > 0
        ? Math.round(lineAllocation / entry.quantity)
        : 0;
      allocations[String(entry.item.key || '')] = Math.max(perUnit, 0);
    });

    return allocations;
  }

  function syncCartPageLinePrice($pageItem, item, bundleUnitDiscount) {
    if (!$pageItem || !$pageItem.length || !item) return;

    // BOGO-regels hebben bewust role-based prijsweergave in Liquid.
    if ($pageItem.attr("data-bogo-role")) return;

    const finalPrice = Number(item.final_price);
    const originalPrice = Number(item.original_price);
    const compareAtPrice = Number(getLineCompareAtPrice(item));
    const bundleDiscount = Math.max(Number(bundleUnitDiscount) || 0, 0);

    const baseCurrent = !isNaN(finalPrice) && finalPrice >= 0
      ? finalPrice
      : (!isNaN(originalPrice) && originalPrice >= 0 ? originalPrice : 0);
    const current = Math.max(baseCurrent - bundleDiscount, 0);

    let oldPrice = 0;
    if (!isNaN(compareAtPrice) && compareAtPrice > current) {
      oldPrice = compareAtPrice;
    }
    if (!isNaN(originalPrice) && originalPrice > current && originalPrice > oldPrice) {
      oldPrice = originalPrice;
    }

    let $current = $pageItem.find("[data-cart-page-line-price]").first();
    if (!$current.length) {
      $current = $pageItem.find(".r2b-cart__item-prices .r2b-cart__price").last();
    }
    if ($current.length) {
      $current.text(formatCartMoney(current));
    }

    let $compare = $pageItem.find("[data-cart-page-line-compare]").first();
    if (!$compare.length && $current.length) {
      $compare = $('<span class="r2b-cart__price--compare" data-cart-page-line-compare hidden></span>');
      $current.before($compare);
    }

    let $badge = $pageItem.find("[data-cart-page-line-discount]").first();
    if (!$badge.length && $current.length) {
      $badge = $('<span class="r2b-cart__discount-badge" data-cart-page-line-discount hidden></span>');
      $current.before($badge);
    }

    if (oldPrice > current) {
      if ($compare.length) {
        $compare.text(formatCartMoney(oldPrice)).removeAttr("hidden");
      }

      const discountPercent = Math.round(((oldPrice - current) / oldPrice) * 100);
      if ($badge.length && discountPercent > 0) {
        $badge.text(discountPercent + "% korting").removeAttr("hidden");
      } else if ($badge.length) {
        $badge.attr("hidden", true).text("");
      }
    } else {
      if ($compare.length) $compare.attr("hidden", true).text("");
      if ($badge.length) $badge.attr("hidden", true).text("");
    }

    if (!isNaN(originalPrice) && originalPrice >= 0) {
      $pageItem.attr("data-original-price", originalPrice);
    }
    if (!isNaN(compareAtPrice) && compareAtPrice > 0) {
      $pageItem.attr("data-compare-at-price", compareAtPrice);
    }
  }

  function reconcileLinesFromCart(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return;

    const bundleAllocations = getR2bBundleCartLevelAllocations(cartData);

    cartData.items.forEach(function (item, index) {
      const line = index + 1;
      const key = item.key;
      const qty = item.quantity;

      const $drawerItem = key
        ? findCartDrawerItem(key, line)
        : $(".cart-drawer__items .cart-drawer__item").eq(index);
      if ($drawerItem.length) {
        if (key) {
          $drawerItem.attr("data-line-key", key);
          $drawerItem.find("[data-line-key]").attr("data-line-key", key);
        }
        $drawerItem.attr("data-line", line);
        applyOptimisticLineQuantity($drawerItem, qty, "drawer");
      }

      const $pageItem = key
        ? findCartPageItem(key, line)
        : $(".r2b-cart__items .r2b-cart__item").eq(index);
      if ($pageItem.length) {
        if (key) {
          $pageItem.attr("data-line-key", key);
          $pageItem.find("[data-line-key]").attr("data-line-key", key);
        }
        $pageItem.attr("data-line", line);
        $pageItem.find("[data-line]").attr("data-line", line);
        applyOptimisticLineQuantity($pageItem, qty, "page");
        syncCartPageLinePrice($pageItem, item, bundleAllocations[String(item.key || "")] || 0);
      }
    });
  }

  function findCartDrawerItem(lineKey, lineNumber) {
    if (lineKey) {
      const $byKey = $(".cart-drawer__item").filter(function () {
        return $(this).attr("data-line-key") === lineKey;
      });
      if ($byKey.length) return $byKey.first();
    }
    if (lineNumber) {
      return $(
        '.cart-drawer__item[data-line="' + String(lineNumber) + '"]'
      ).first();
    }
    return $();
  }

  function findCartPageItem(lineKey, lineNumber) {
    if (lineKey) {
      const $byKey = $(".r2b-cart__item").filter(function () {
        return $(this).attr("data-line-key") === lineKey;
      });
      if ($byKey.length) return $byKey.first();
    }
    if (lineNumber) {
      return $(
        '.r2b-cart__item[data-line="' + String(lineNumber) + '"]'
      ).first();
    }
    return $();
  }

  function bumpCartItemCount(delta) {
    if (!delta) return;
    const currentCount = parseInt(
      ($("[data-cart-drawer-count]").first().text() ||
        $("[data-cart-page-count]").first().text() ||
        (window.cart && window.cart.quantity) ||
        0),
      10
    );
    if (isNaN(currentCount)) return;
    const nextCount = Math.max(currentCount + delta, 0);
    $("[data-cart-drawer-count]").text(nextCount);
    $("[data-cart-page-count]").text(nextCount);
    $(".header-cart .badge-cart").text(nextCount);
    if (window.cart) window.cart.quantity = nextCount;
  }

  function applyOptimisticLineQuantity($item, quantity, context) {
    if (!$item || !$item.length) return;
    const qty = parseInt(quantity, 10);
    if (isNaN(qty) || qty < 1) return;

    $item.attr("data-quantity", qty);

    if (context === "drawer") {
      $item.find(".cart-drawer__qty-input").val(qty);
      $item
        .find('[data-cart-drawer-qty][data-qty-action="minus"]')
        .attr("data-quantity", Math.max(qty - 1, 0));
      $item
        .find('[data-cart-drawer-qty][data-qty-action="plus"]')
        .attr("data-quantity", qty + 1);
    } else {
      $item.find(".r2b-cart__qty-input").val(qty);
      $item
        .find("[data-cart-variant-dropdown]")
        .attr("data-quantity", qty);
    }
  }

  function renumberCartLineIndexes() {
    $(".cart-drawer__items .cart-drawer__item").each(function (index) {
      $(this).attr("data-line", index + 1);
    });
    $(".r2b-cart__items .r2b-cart__item").each(function (index) {
      const line = index + 1;
      $(this).attr("data-line", line);
      $(this).find("[data-line]").attr("data-line", line);
    });
  }

  function applyOptimisticLineRemove(lineKey, lineNumber) {
    const $drawerItem = findCartDrawerItem(lineKey, lineNumber);
    const $pageItem = findCartPageItem(lineKey, lineNumber);
    let removedQty = 0;

    if ($drawerItem.length) {
      removedQty =
        parseInt($drawerItem.find(".cart-drawer__qty-input").val(), 10) ||
        parseInt($drawerItem.attr("data-quantity"), 10) ||
        1;
      $drawerItem.remove();
    }
    if ($pageItem.length) {
      if (!removedQty) {
        removedQty =
          parseInt($pageItem.find(".r2b-cart__qty-input").val(), 10) ||
          parseInt($pageItem.attr("data-quantity"), 10) ||
          1;
      }
      $pageItem.remove();
    }

    renumberCartLineIndexes();

    if (removedQty > 0) {
      bumpCartItemCount(-removedQty);
    }

    const remainingDrawer = $(".cart-drawer__items .cart-drawer__item").length;
    const remainingPage = $(".r2b-cart__items .r2b-cart__item").length;

    if (!remainingDrawer) {
      const $body = $("[data-cart-drawer-body]");
      if ($body.length && !$body.find(".cart-drawer__empty").length) {
        $body.html('<div class="cart-drawer__empty"></div>');
      }
      const $footer = $("[data-cart-drawer-footer]");
      $footer
        .addClass("cart-drawer__footer--empty")
        .find(
          ".cart-drawer__summary, .cart-drawer__checkout, .cart-drawer__view-cart"
        )
        .remove();
    }

    if (!remainingPage && $(".main_cart-section").length) {
      // Empty-state markup is applied after the API confirms via refreshCartPage
    }

    window.requestAnimationFrame(function () {
      updateCartDrawerScrollClass();
    });
  }

  function findCartLineItemEl(lineKey, lineNumber) {
    const $drawer = findCartDrawerItem(lineKey, lineNumber);
    if ($drawer.length) return $drawer.first();
    const $page = findCartPageItem(lineKey, lineNumber);
    if ($page.length) return $page.first();
    return $();
  }

  function getBogoItemScope($item) {
    if (!$item || !$item.length) return $();
    if ($item.hasClass("cart-drawer__item")) {
      return $item.parent().children(".cart-drawer__item");
    }
    if ($item.hasClass("r2b-cart__item")) {
      return $item.parent().children(".r2b-cart__item");
    }
    return $();
  }

  function getBogoLineRef($el) {
    if (!$el || !$el.length) return null;
    return {
      lineKey: $el.attr("data-line-key") || null,
      lineNumber: $el.attr("data-line") || null,
    };
  }

  // Pair a BOGO line with its counterpart in the same deal only (same _bogo_group).
  // Never fall back to "any free item" — that links the wrong deal when 2+ bundles exist.
  function findBogoLinkedCompanion(lineKey, lineNumber, wantedRole) {
    const $item = findCartLineItemEl(lineKey, lineNumber);
    if (!$item.length) return null;

    const role = ($item.attr("data-bogo-role") || "").trim();
    if (!role) return null;

    const targetRole = wantedRole || (role === "paid" ? "free" : "paid");
    if (role === targetRole) return null;

    const group = ($item.attr("data-bogo-group") || "").trim();
    const $scope = getBogoItemScope($item);
    let $match = $();

    if (group && $scope.length) {
      $match = $scope.filter(function () {
        return (
          $(this).attr("data-bogo-role") === targetRole &&
          ($(this).attr("data-bogo-group") || "") === group
        );
      });
    }

    if (!$match.length) {
      const $neighbor = targetRole === "free" ? $item.next() : $item.prev();
      if (
        $neighbor &&
        $neighbor.length &&
        $neighbor.attr("data-bogo-role") === targetRole
      ) {
        $match = $neighbor;
      }
    }

    return getBogoLineRef($match.first());
  }

  function findBogoFreeCompanion(lineKey, lineNumber) {
    const $item = findCartLineItemEl(lineKey, lineNumber);
    if (!$item.length || $item.attr("data-bogo-role") !== "paid") return null;
    return findBogoLinkedCompanion(lineKey, lineNumber, "free");
  }

  function getBogoFreeCompanionState(lineKey, lineNumber) {
    const companion = findBogoFreeCompanion(lineKey, lineNumber);
    if (!companion) return null;

    const $drawer = findCartDrawerItem(companion.lineKey, companion.lineNumber);
    const $page = findCartPageItem(companion.lineKey, companion.lineNumber);
    const $el = $drawer.length ? $drawer : $page;
    const qtyFromInput = parseInt(
      $el.find(".cart-drawer__qty-input, .r2b-cart__qty-input").first().val(),
      10
    );
    const qtyFromAttr = parseInt($el.attr("data-quantity"), 10);

    return {
      lineKey: companion.lineKey,
      lineNumber: companion.lineNumber,
      $drawer: $drawer,
      $page: $page,
      quantity: !isNaN(qtyFromInput)
        ? qtyFromInput
        : !isNaN(qtyFromAttr)
          ? qtyFromAttr
          : 1,
      maxQty: parseInt($el.attr("data-max-qty"), 10) || 99,
    };
  }

  function applyBogoFreeCompanionQuantity(companion, quantity) {
    if (!companion) return;
    applyOptimisticLineQuantity(companion.$drawer, quantity, "drawer");
    applyOptimisticLineQuantity(companion.$page, quantity, "page");
  }

  function getR2bBundleGroupFromCartItem(item) {
    const props = (item && item.properties) || {};
    return String(props._r2b_bundle_group || '').trim();
  }

  function collectR2bBundleGroupUpdates(cartData, group) {
    const updates = {};
    if (!cartData || !Array.isArray(cartData.items) || !group) return updates;
    cartData.items.forEach(function (item) {
      if (item && item.key && getR2bBundleGroupFromCartItem(item) === String(group)) {
        updates[String(item.key)] = 0;
      }
    });
    return updates;
  }

  async function removeWholeR2bBundleIfNeeded(lineKey, lineNumber) {
    try {
      const cartData = await getAjax('/cart.js', 'GET', 'json');
      const items = (cartData && cartData.items) || [];
      const current = items.find(function (item) {
        return lineKey && String(item.key) === String(lineKey);
      }) || (lineNumber ? items[parseInt(lineNumber, 10) - 1] : null);

      if (!current) return false;
      const group = getR2bBundleGroupFromCartItem(current);
      if (!group) return false;

      const updates = collectR2bBundleGroupUpdates(cartData, group);
      const keys = Object.keys(updates);
      if (!keys.length) return false;

      const latest = await runCartApi(async function () {
        return await postAjaxJson('/cart/update.js', { updates: updates });
      });

      const drawerOpen = $('#CartDrawer').hasClass('active');
      if (latest) syncCartSummariesFromCart(latest, drawerOpen ? 'page' : 'all');
      if ($('.main_cart-section').length || $('[data-cart-page]').length) await refreshCartPage();
      await softRefreshCartDrawer(drawerOpen, { preserveItems: false });
      cacheCompareAtFromDom();
      return true;
    } catch (error) {
      console.error('R2B bundel verwijderen:', error);
      return false;
    }
  }

  async function removeLineWithBogoCompanion(lineKey, lineNumber) {
    if (await removeWholeR2bBundleIfNeeded(lineKey, lineNumber)) return;

    const $item = findCartLineItemEl(lineKey, lineNumber);
    const group = ($item.attr("data-bogo-group") || "").trim();
    const role = ($item.attr("data-bogo-role") || "").trim();
    const companion =
      role === "paid"
        ? findBogoLinkedCompanion(lineKey, lineNumber, "free")
        : role === "free"
          ? findBogoLinkedCompanion(lineKey, lineNumber, "paid")
          : null;

    const extraKeys = [];
    if (companion && companion.lineKey && String(companion.lineKey) !== String(lineKey || "")) {
      extraKeys.push(String(companion.lineKey));
    }
    if (lineKey) extraKeys.push(String(lineKey));

    // Drop in-flight +/− updates so they cannot restore qty after delete.
    cartMutationGeneration += 1;
    invalidateCartLineQueues(extraKeys);
    if (group) {
      $(".cart-drawer__item, .r2b-cart__item").each(function () {
        if (($(this).attr("data-bogo-group") || "") !== group) return;
        invalidateCartLineQueues([$(this).attr("data-line-key")]);
      });
    }

    extraKeys.forEach(function (key) {
      applyOptimisticLineRemove(
        key,
        key === String(lineKey || "") ? lineNumber : companion && companion.lineNumber
      );
    });
    if (group) {
      const groupKeys = [];
      $(".cart-drawer__item, .r2b-cart__item").each(function () {
        if (($(this).attr("data-bogo-group") || "") !== group) return;
        groupKeys.push({
          key: $(this).attr("data-line-key"),
          line: $(this).attr("data-line"),
        });
      });
      groupKeys.forEach(function (ref) {
        applyOptimisticLineRemove(ref.key, ref.line);
      });
    }

    try {
      const cartData = await runCartApi(async function () {
        let latest = await getAjax("/cart.js", "GET", "json");
        let updates = collectBogoGroupKeys(latest, group, extraKeys);
        if (!Object.keys(updates).length && lineKey) {
          updates[String(lineKey)] = 0;
        }
        if (Object.keys(updates).length) {
          latest = await postAjaxJson("/cart/update.js", { updates: updates });
        }
        const leftover = collectBogoGroupKeys(latest, group, []);
        if (Object.keys(leftover).length) {
          latest = await postAjaxJson("/cart/update.js", { updates: leftover });
        }
        return latest;
      });

      const drawerOpen = $("#CartDrawer").hasClass("active");
      if (cartData) {
        syncCartSummariesFromCart(cartData, drawerOpen ? "page" : "all");
      }
      if ($(".main_cart-section").length || $("[data-cart-page]").length) {
        await refreshCartPage();
      }
      await softRefreshCartDrawer(drawerOpen, { preserveItems: false });
      cacheCompareAtFromDom();
      return cartData;
    } catch (error) {
      console.error("BOGO cart remove:", error);
      if ($(".main_cart-section").length) {
        await refreshCartPage();
      }
      await softRefreshCartDrawer($("#CartDrawer").hasClass("active"));
      cacheCompareAtFromDom();
    }
  }

  function syncHeaderFromCart(cartData) {
    if (!cartData) return;
    if (typeof cartData.item_count !== "undefined") {
      window.cart.quantity = cartData.item_count;
      $(".header-cart .badge-cart").text(cartData.item_count);
    }
    if (typeof cartData.items_subtotal_price !== "undefined") {
      window.cart.total_price = cartData.items_subtotal_price;
    } else if (typeof cartData.total_price !== "undefined") {
      window.cart.total_price = cartData.total_price;
    }
  }

  function getLineCompareAtPrice(item) {
    if (!item) return 0;

    if (!window.__r2bCompareAtByKey) window.__r2bCompareAtByKey = {};
    if (!window.__r2bCompareAtByVariant) window.__r2bCompareAtByVariant = {};

    // 1) Cart API (when present)
    const apiCompare = Number(item.compare_at_price);
    if (apiCompare > 0) {
      if (item.key) window.__r2bCompareAtByKey[item.key] = apiCompare;
      if (item.variant_id) {
        window.__r2bCompareAtByVariant[String(item.variant_id)] = apiCompare;
      }
      return apiCompare;
    }

    // 2) Cache from earlier Liquid renders
    if (item.key && window.__r2bCompareAtByKey[item.key] > 0) {
      return Number(window.__r2bCompareAtByKey[item.key]);
    }
    if (
      item.variant_id &&
      window.__r2bCompareAtByVariant[String(item.variant_id)] > 0
    ) {
      return Number(window.__r2bCompareAtByVariant[String(item.variant_id)]);
    }

    // 3) DOM line attributes / AIOD markup
    const $line = item.key
      ? $(".cart-drawer__item, .r2b-cart__item").filter(function () {
          return $(this).attr("data-line-key") === item.key;
        })
      : $();

    let compareAt = 0;
    if ($line.length) {
      compareAt = Number($line.attr("data-compare-at-price")) || 0;
      if (!compareAt) {
        const aiodCompare = $line
          .find("[product-compare-at-price]")
          .first()
          .attr("product-compare-at-price");
        compareAt = Number(aiodCompare) || 0;
      }
      if (compareAt > 0) {
        if (item.key) window.__r2bCompareAtByKey[item.key] = compareAt;
        const variantId =
          item.variant_id || $line.attr("data-variant-id");
        if (variantId) {
          window.__r2bCompareAtByVariant[String(variantId)] = compareAt;
        }
      }
    }

    return compareAt > 0 ? compareAt : 0;
  }

  function cacheCompareAtFromDom($root) {
    if (!window.__r2bCompareAtByKey) window.__r2bCompareAtByKey = {};
    if (!window.__r2bCompareAtByVariant) window.__r2bCompareAtByVariant = {};
    const $scope = $root && $root.length ? $root : $(document);
    $scope.find(".cart-drawer__item, .r2b-cart__item").each(function () {
      const $item = $(this);
      const key = $item.attr("data-line-key");
      const variantId = $item.attr("data-variant-id");
      let compareAt = Number($item.attr("data-compare-at-price")) || 0;
      if (!compareAt) {
        compareAt =
          Number(
            $item.find("[product-compare-at-price]").attr("product-compare-at-price")
          ) || 0;
      }
      if (compareAt > 0) {
        if (key) window.__r2bCompareAtByKey[key] = compareAt;
        if (variantId) {
          window.__r2bCompareAtByVariant[String(variantId)] = compareAt;
        }
      }
    });
  }

  function getCompareAtSavings(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return 0;
    let savings = 0;
    cartData.items.forEach(function (item) {
      const compareAt = getLineCompareAtPrice(item);
      const originalPrice = Number(item.original_price) || 0;
      const quantity = Number(item.quantity) || 0;
      if (compareAt > originalPrice && quantity > 0) {
        savings += (compareAt - originalPrice) * quantity;
      }
    });
    return savings;
  }

  function getCartDiscountAmount(cartData) {
    if (!cartData) return 0;
    let discount = Number(cartData.total_discount) || 0;
    if (
      !discount &&
      cartData.original_total_price > cartData.total_price
    ) {
      discount = cartData.original_total_price - cartData.total_price;
    }
    return discount + getCompareAtSavings(cartData);
  }

  function syncCartSummariesFromCart(cartData, scope) {
    if (!cartData) return;
    // scope: "all" (default) | "page" | "drawer"
    // When the drawer is about to refresh from Liquid, skip "drawer" so JS/Liquid
    // money formats don't flash over each other (the € bobbing).
    scope = scope || "all";
    const syncPage = scope === "all" || scope === "page";
    const syncDrawer = scope === "all" || scope === "drawer";

    syncHeaderFromCart(cartData);

    const count = cartData.item_count;
    const total = cartData.total_price;
    const discount = getCartDiscountAmount(cartData);
    const displayOriginal =
      typeof total !== "undefined" ? Number(total) + discount : 0;

    if (syncDrawer) $("[data-cart-drawer-count]").text(count);
    if (syncPage) $("[data-cart-page-count]").text(count);

    if (typeof total !== "undefined") {
      const totalHtml = formatCartMoney(total);
      if (syncDrawer) $("[data-cart-drawer-total]").text(totalHtml);
      if (syncPage) $("[data-cart-page-total]").text(totalHtml);
    }

    const $drawerOriginal = $("[data-cart-drawer-original-total]");
    const $pageOriginal = $("[data-cart-page-original-total]");
    if (displayOriginal > total) {
      const originalHtml = formatCartMoney(displayOriginal);
      if (syncDrawer && $drawerOriginal.length) {
        $drawerOriginal.text(originalHtml).removeAttr("hidden");
      }
      if (syncPage && $pageOriginal.length) {
        $pageOriginal.text(originalHtml).removeAttr("hidden");
      }
    } else {
      if (syncDrawer) $drawerOriginal.attr("hidden", true);
      if (syncPage) $pageOriginal.attr("hidden", true);
    }

    if (syncDrawer) {
      const $drawerDiscount = $("[data-cart-drawer-discount]");
      const $drawerDiscountRow = $("[data-cart-drawer-discount-row]");
      if ($drawerDiscount.length) {
        if (discount > 0) {
          $drawerDiscount.text(formatCartMoney(discount));
          $drawerDiscountRow.removeAttr("hidden");
        } else {
          $drawerDiscountRow.attr("hidden", true);
        }
      }
    }

    if (syncPage) {
      const $pageDiscount = $("[data-cart-page-discount]");
      if ($pageDiscount.length) {
        if (discount > 0) {
          $pageDiscount.text(formatCartMoney(discount));
          $("[data-cart-page-discount-row]").removeAttr("hidden");
        } else {
          $("[data-cart-page-discount-row]").attr("hidden", true);
        }
      }
    }
  }

  function openCartDrawerRemoveModal(lineKey, title, imageUrl, lineNumber, productUrl) {
    const $modal = $("#CartDrawerRemoveModal");
    if (!$modal.length || (!lineKey && !lineNumber)) return;

    pendingRemoveLineKey = lineKey || null;
    pendingRemoveLine = lineNumber || null;
    $modal.find("[data-remove-modal-title]").text(title || "");
    const $img = $modal.find("[data-remove-modal-image]");
    if (imageUrl) {
      $img.attr("src", imageUrl).attr("alt", title || "").show();
    } else {
      $img.attr("src", "").attr("alt", "").hide();
    }

    const href = productUrl || "#";
    $modal.find("[data-remove-modal-product-link]").each(function () {
      const $link = $(this);
      if (productUrl) {
        $link.attr("href", href).removeAttr("aria-disabled").removeClass("is-disabled");
      } else {
        $link.attr("href", "#").attr("aria-disabled", "true").addClass("is-disabled");
      }
    });

    $modal.addClass("active").attr("aria-hidden", "false");
    $("html").addClass("cart-drawer-remove-modal-active");
  }

  function closeCartDrawerRemoveModal() {
    const $modal = $("#CartDrawerRemoveModal");
    pendingRemoveLineKey = null;
    pendingRemoveLine = null;
    if (!$modal.length) return;
    $modal.removeClass("active").attr("aria-hidden", "true");
    $("html").removeClass("cart-drawer-remove-modal-active");
  }

  function bindCartDrawerEvents() {
    const $drawer = $("#CartDrawer");
    if (!$drawer.length) return;

    bindCartDrawerSwipe($drawer);

   $drawer
      .off("click.cartDrawerClose", "[data-cart-drawer-close]")
      .on("click.cartDrawerClose", "[data-cart-drawer-close]", function (e) {
        const el = this;
        const href =
          el.tagName === "A" ? (el.getAttribute("href") || "").trim() : "";
        const isNavLink =
          href.length > 0 && href !== "#" && el.getAttribute("aria-disabled") !== "true";

        if (!isNavLink) {
          e.preventDefault();
        }
        closeCartDrawer();
      });

    $(window)
      .off("resize.cartDrawerScroll")
      .on("resize.cartDrawerScroll", function () {
        if ($("#CartDrawer").hasClass("active")) {
          updateCartDrawerScrollClass();
        }
      });

    $drawer
      .off("scroll.cartDrawerBody", "[data-cart-drawer-body]")
      .on("scroll.cartDrawerBody", "[data-cart-drawer-body]", function () {
        updateCartDrawerScrollClass();
      });

    $drawer
      .off("click.cartDrawerQty", "[data-cart-drawer-qty]")
      .on("click.cartDrawerQty", "[data-cart-drawer-qty]", function (e) {
        e.preventDefault();
        const $btn = $(this);
        const lineKey = $btn.attr("data-line-key");
        const $item = $btn.closest(".cart-drawer__item");
        const line = $item.attr("data-line");
        const quantity = parseInt($btn.attr("data-quantity"), 10);
        if (!lineKey && !line) return;
        // Pair 2 (free) qty is locked — it only follows Pair 1.
        if ($item.attr("data-bogo-role") === "free" && $item.attr("data-bogo-bundle") !== "2-plus-1") return;

        // All three 2+1 pairs behave like the trash button on minus.
        // The existing confirmation handler removes the complete linked group.
        if ($item.attr("data-bogo-bundle") === "2-plus-1") {
          if ($btn.attr("data-qty-action") === "plus") return;
          if ($btn.attr("data-qty-action") === "minus") {
            const title = $.trim($item.find(".cart-drawer__item-title").text());
            const imageUrl = $item.find(".cart-drawer__item-image img").attr("src") || "";
            const productUrl = $item.find(".cart-drawer__item-title").attr("href") || "";
            openCartDrawerRemoveModal(lineKey, title, imageUrl, line, productUrl);
            return;
          }
        }

        // Minus to 0 → show remove confirmation popup
        if (
          $btn.attr("data-qty-action") === "minus" &&
          (isNaN(quantity) || quantity < 1)
        ) {
          const title = $.trim($item.find(".cart-drawer__item-title").text());
          const imageUrl =
            $item.find(".cart-drawer__item-image img").attr("src") ||
            $item.find(".cart-drawer__item-image img").attr("data-src") ||
            "";
          const productUrl =
            $item.find(".cart-drawer__item-title").attr("href") ||
            $item.find(".cart-drawer__item-image").attr("href") ||
            "";
          openCartDrawerRemoveModal(lineKey, title, imageUrl, line, productUrl);
          return;
        }

        if (isNaN(quantity) || quantity < 1) return;

        const companion = getBogoFreeCompanionState(lineKey, line);
        let maxQty = parseInt($item.attr("data-max-qty"), 10) || 99;
        if (companion) maxQty = Math.min(maxQty, companion.maxQty);
        if ($btn.attr("data-qty-action") === "plus" && quantity > maxQty) return;

        const nextQty = Math.min(quantity, maxQty);
        const prevQty =
          parseInt($item.find(".cart-drawer__qty-input").val(), 10) || 1;
        applyOptimisticLineQuantity($item, nextQty, "drawer");
        applyOptimisticLineQuantity(
          findCartPageItem(lineKey, line),
          nextQty,
          "page"
        );
        let countDelta = nextQty - prevQty;
        if (companion) {
          countDelta += nextQty - companion.quantity;
          applyBogoFreeCompanionQuantity(companion, nextQty);
        }
        bumpCartItemCount(countDelta);
        enqueueCartLineUpdate(lineKey, line, nextQty);
      });

    $drawer
      .off("click.cartDrawerRemove", "[data-cart-drawer-remove]")
      .on("click.cartDrawerRemove", "[data-cart-drawer-remove]", function (e) {
        e.preventDefault();
        const $btn = $(this);
        const lineKey = $btn.attr("data-line-key");
        const $item = $btn.closest(".cart-drawer__item");
        const line = $item.attr("data-line");
        if (!lineKey && !line) return;

        const title = $.trim($item.find(".cart-drawer__item-title").text());
        const imageUrl =
          $item.find(".cart-drawer__item-image img").attr("src") ||
          $item.find(".cart-drawer__item-image img").attr("data-src") ||
          "";
        const productUrl =
          $item.find(".cart-drawer__item-title").attr("href") ||
          $item.find(".cart-drawer__item-image").attr("href") ||
          "";

        openCartDrawerRemoveModal(lineKey, title, imageUrl, line, productUrl);
      });

    const $modal = $("#CartDrawerRemoveModal");
    if ($modal.length) {
      $modal
        .off("click.removeModalClose", "[data-remove-modal-close]")
        .on("click.removeModalClose", "[data-remove-modal-close]", function (e) {
          e.preventDefault();
          closeCartDrawerRemoveModal();
        });

      $modal
        .off("click.removeModalConfirm", "[data-remove-modal-confirm]")
        .on("click.removeModalConfirm", "[data-remove-modal-confirm]", function (e) {
          e.preventDefault();
          const lineKey = pendingRemoveLineKey;
          const line = pendingRemoveLine;
          closeCartDrawerRemoveModal();
          if (!lineKey && !line) return;

          removeLineWithBogoCompanion(lineKey, line);
        });
    }
  }

  function enqueueCartLineUpdate(lineKey, lineNumber, quantity) {
    const queueId = getCartLineQueueId(lineKey, lineNumber);
    if (!cartLineUpdateQueues[queueId]) {
      cartLineUpdateQueues[queueId] = {
        pending: null,
        running: false,
        requestSeq: 0,
      };
    }
    cartLineUpdateQueues[queueId].pending = {
      lineKey: lineKey,
      lineNumber: lineNumber,
      quantity: quantity,
    };
    drainCartLineQueue(queueId);
  }

  async function drainCartLineQueue(queueId) {
    const queue = cartLineUpdateQueues[queueId];
    if (!queue || queue.running) return;
    queue.running = true;

    try {
      while (queue.pending) {
        const job = queue.pending;
        queue.pending = null;
        queue.requestSeq += 1;
        const seq = queue.requestSeq;
        await performCartLineUpdate(
          job.lineKey,
          job.quantity,
          job.lineNumber,
          queueId,
          seq
        );
      }
    } finally {
      queue.running = false;
      if (queue.pending) {
        drainCartLineQueue(queueId);
      }
    }
  }

  async function performCartLineUpdate(
    lineKey,
    quantity,
    lineNumber,
    queueId,
    seq
  ) {
    const queue = cartLineUpdateQueues[queueId];
    const gen = cartMutationGeneration;

    // If the line was already removed from the DOM for a qty=0 job, keep 0.
    // Otherwise always send the latest optimistic qty from the input.
    let targetQty = parseInt(quantity, 10);
    if (targetQty !== 0) {
      const liveQty = getOptimisticQuantity(lineKey, lineNumber);
      if (liveQty !== null) targetQty = liveQty;
    }

    // A newer click already replaced this job — skip the stale request
    if (queue && queue.pending) return;
    if (queue && typeof seq === "number" && seq !== queue.requestSeq) return;

    try {
      const $lineItem = findCartLineItemEl(lineKey, lineNumber);
      const bogoRole = ($lineItem.attr("data-bogo-role") || "").trim();
      const companion =
        targetQty > 0 && bogoRole === "paid"
          ? findBogoFreeCompanion(lineKey, lineNumber)
          : null;
      let cartData;

      if (targetQty > 0 && bogoRole === "paid" && lineKey) {
        if (companion && companion.lineKey) {
          const freeQueueId = getCartLineQueueId(
            companion.lineKey,
            companion.lineNumber
          );
          if (cartLineUpdateQueues[freeQueueId]) {
            cartLineUpdateQueues[freeQueueId].pending = null;
            cartLineUpdateQueues[freeQueueId].requestSeq += 1;
          }
        }
        cartData = await updateBogoPairQuantities(
          String(lineKey),
          companion && companion.lineKey ? String(companion.lineKey) : null,
          targetQty
        );
      } else {
        const liveLine =
          targetQty === 0 ? null : resolveCartLineNumber(lineKey, lineNumber);
        cartData = await changeCartLineQuantity({
          lineKey: lineKey,
          line: liveLine || lineNumber,
          quantity: targetQty,
          preferKey: targetQty === 0 || !!bogoRole,
        });
        if (bogoRole) {
          cartData = await normalizeBogoCart(cartData);
        }
      }

      // Ignore outdated responses when a newer update is queued/running
      if (queue && queue.pending) return;
      if (queue && typeof seq === "number" && seq !== queue.requestSeq) return;
      if (gen !== cartMutationGeneration) return;
      if (!cartData) return;

      // Cart page needs an immediate API sync. Open drawer totals refresh from
      // Liquid only — writing both JS + Liquid formats causes the € bobbing.
      const drawerOpen = $("#CartDrawer").hasClass("active");
      syncCartSummariesFromCart(cartData, drawerOpen ? "page" : "all");

      if (targetQty > 0) {
        if (cartDomLineCountMismatch(cartData)) {
          if ($(".main_cart-section").length || $("[data-cart-page]").length) {
            await refreshCartPage();
          }
          await softRefreshCartDrawer(drawerOpen, { preserveItems: false });
          cacheCompareAtFromDom();
        } else {
          reconcileLinesFromCart(cartData);
          cacheCompareAtFromDom();
          try {
            await refreshCartSummariesFromLiquid();
          } catch (refreshError) {
            console.warn("Cart summary liquid refresh:", refreshError);
            if (drawerOpen) syncCartSummariesFromCart(cartData, "drawer");
          }
        }
      } else {
        if ($(".main_cart-section").length || $("[data-cart-page]").length) {
          await refreshCartPage();
        }
        await softRefreshCartDrawer(drawerOpen, {
          preserveItems: false,
        });
        cacheCompareAtFromDom();
      }
    } catch (error) {
      console.error("Cart line update:", error);
      if (queue && queue.pending) return;
      if (queue && typeof seq === "number" && seq !== queue.requestSeq) return;
      if (gen !== cartMutationGeneration) return;
      if ($(".main_cart-section").length) {
        await refreshCartPage();
      }
      await softRefreshCartDrawer($("#CartDrawer").hasClass("active"));
      cacheCompareAtFromDom();
    }
  }

  // Back-compat wrapper used by older call sites
  async function updateCartDrawerLine(lineKey, quantity, lineNumber) {
    if (quantity === 0) {
      applyOptimisticLineRemove(lineKey, lineNumber);
    } else {
      applyOptimisticLineQuantity(
        findCartDrawerItem(lineKey, lineNumber),
        quantity,
        "drawer"
      );
      applyOptimisticLineQuantity(
        findCartPageItem(lineKey, lineNumber),
        quantity,
        "page"
      );
    }
    enqueueCartLineUpdate(lineKey, lineNumber, quantity);
  }

  function getBogoPropertiesFromCartItemEl($item) {
    if (!$item || !$item.length) return {};
    const role = ($item.attr("data-bogo-role") || "").trim();
    if (!role) return {};
    const properties = {
      _bogo_role: role,
      _bogo_pair: role === "free" ? "2" : "1",
      _bogo_bundle: "1-plus-1",
    };
    const group = ($item.attr("data-bogo-group") || "").trim();
    if (group) properties._bogo_group = group;
    return properties;
  }

  function hasCartLineProperties(properties) {
    return !!(properties && Object.keys(properties).length);
  }

  // Cart page variant change must copy line properties and keep Pair 1 above Pair 2.
  // Shopify add.js always prepends the new line, so Pair 2 would otherwise jump
  // to the top and lose _bogo_role (title + €0.00).
  async function changeCartPageVariant(lineKey, line, newVariantId, quantity) {
    const variantId = parseInt(newVariantId, 10) || newVariantId;
    let properties = {};
    let paidCompanion = null;

    try {
      const cartData = await getAjax("/cart.js", "GET", "json");
      const items = (cartData && cartData.items) || [];
      const current =
        items.find(function (item) {
          return String(item.key) === String(lineKey);
        }) ||
        (line ? items[parseInt(line, 10) - 1] : null);

      if (current) {
        properties = current.properties || {};
        const role = properties._bogo_role;
        const group = properties._bogo_group;
        if (role === "free") {
          paidCompanion =
            items.find(function (item) {
              if (String(item.key) === String(current.key)) return false;
              const itemProps = item.properties || {};
              if (itemProps._bogo_role !== "paid") return false;
              if (!group) return true;
              return itemProps._bogo_group === group;
            }) || null;
        }
      }
    } catch (err) {}

    if (!hasCartLineProperties(properties)) {
      properties = getBogoPropertiesFromCartItemEl(
        findCartPageItem(lineKey, line)
      );
    }

    if (!paidCompanion && properties._bogo_role === "free") {
      const group = properties._bogo_group || "";
      const $paid = $(".r2b-cart__item").filter(function () {
        if ($(this).attr("data-bogo-role") !== "paid") return false;
        if (!group) return true;
        return ($(this).attr("data-bogo-group") || "") === group;
      }).first();
      if ($paid.length) {
        paidCompanion = {
          key: $paid.attr("data-line-key"),
          variant_id: $paid.attr("data-variant-id"),
          quantity:
            parseInt($paid.attr("data-quantity"), 10) ||
            parseInt($paid.find(".r2b-cart__qty-input").val(), 10) ||
            1,
          properties: getBogoPropertiesFromCartItemEl($paid),
        };
      }
    }

    await changeCartLineQuantity({
      lineKey: lineKey,
      line: line,
      quantity: 0,
      preferKey: !!lineKey,
    });

    if (paidCompanion && (paidCompanion.key || paidCompanion.variant_id)) {
      await changeCartLineQuantity({
        lineKey: paidCompanion.key,
        quantity: 0,
        preferKey: !!paidCompanion.key,
      });
      await postAjaxJson("/cart/add.js", {
        items: [
          {
            id: variantId,
            quantity: quantity,
            properties: properties,
          },
          {
            id: parseInt(paidCompanion.variant_id, 10) || paidCompanion.variant_id,
            quantity: paidCompanion.quantity || 1,
            properties: paidCompanion.properties || {},
          },
        ],
      });
      return;
    }

    const payload = {
      id: variantId,
      quantity: quantity,
    };
    if (hasCartLineProperties(properties)) {
      payload.properties = properties;
    }
    await postAjaxJson("/cart/add.js", payload);
  }

  function getCartItemProperties(item) {
    return (item && item.properties) || {};
  }

  function collectBogoGroupKeys(cartData, group, extraKeys) {
    const updates = {};
    (extraKeys || []).forEach(function (key) {
      if (key) updates[String(key)] = 0;
    });
    if (cartData && Array.isArray(cartData.items) && group) {
      cartData.items.forEach(function (item) {
        const props = getCartItemProperties(item);
        if (String(props._bogo_group || "") === String(group) && item.key) {
          updates[String(item.key)] = 0;
        }
      });
    }
    return updates;
  }

  function findCartBogoItem(cartData, role, group, fallbackKey) {
    const items = (cartData && cartData.items) || [];
    if (fallbackKey) {
      const byKey = items.find(function (item) {
        if (String(item.key) !== String(fallbackKey)) return false;
        if (!role) return true;
        return getCartItemProperties(item)._bogo_role === role;
      });
      if (byKey) return byKey;
    }
    if (group) {
      return (
        items.find(function (item) {
          const props = getCartItemProperties(item);
          return (
            props._bogo_role === role &&
            String(props._bogo_group || "") === String(group)
          );
        }) || null
      );
    }
    return null;
  }

  function cartDomLineCountMismatch(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return false;
    const apiLines = cartData.items.length;
    const drawerLines = $(".cart-drawer__items .cart-drawer__item").length;
    const pageLines = $(".r2b-cart__items .r2b-cart__item").length;
    if (drawerLines > 0 && drawerLines !== apiLines) return true;
    if (pageLines > 0 && pageLines !== apiLines) return true;
    return false;
  }

  // Collapse duplicate Pair 2 lines and drop free items that no longer have Pair 1.
  async function normalizeBogoCart(cartData, pass) {
    if (!cartData || !Array.isArray(cartData.items)) return cartData;

    const groups = {};
    const orphanFree = [];

    cartData.items.forEach(function (item) {
      const props = getCartItemProperties(item);
      const role = props._bogo_role;
      const group = props._bogo_group;
      if (role !== "paid" && role !== "free") return;
      if (!group) {
        if (role === "free") orphanFree.push(item);
        return;
      }
      if (!groups[group]) groups[group] = { paid: [], free: [] };
      groups[group][role].push(item);
    });

    const jobs = [];

    orphanFree.forEach(function (item) {
      if (item.key) jobs.push({ key: item.key, quantity: 0 });
    });

    Object.keys(groups).forEach(function (groupId) {
      const paidLines = groups[groupId].paid || [];
      const freeLines = groups[groupId].free || [];

      if (!paidLines.length) {
        freeLines.forEach(function (item) {
          if (item.key) jobs.push({ key: item.key, quantity: 0 });
        });
        return;
      }

      paidLines.slice(1).forEach(function (item) {
        if (item.key) jobs.push({ key: item.key, quantity: 0 });
      });

      const targetQty = parseInt(paidLines[0].quantity, 10) || 0;
      if (!freeLines.length) return;

      const keepFree =
        freeLines.find(function (item) {
          return (parseInt(item.quantity, 10) || 0) === targetQty;
        }) || freeLines[0];

      if ((parseInt(keepFree.quantity, 10) || 0) !== targetQty) {
        jobs.push({ key: keepFree.key, quantity: targetQty });
      }
      freeLines.forEach(function (item) {
        if (item.key && String(item.key) !== String(keepFree.key)) {
          jobs.push({ key: item.key, quantity: 0 });
        }
      });
    });

    if (!jobs.length) return cartData;

    const gen = cartMutationGeneration;
    let latest = cartData;
    for (let i = 0; i < jobs.length; i++) {
      if (gen !== cartMutationGeneration) return latest;
      latest = await changeCartLineQuantity({
        lineKey: jobs[i].key,
        quantity: jobs[i].quantity,
        preferKey: true,
      });
    }
    if ((pass || 0) >= 1) return latest;
    if (gen !== cartMutationGeneration) return latest;
    return await normalizeBogoCart(latest, 1);
  }

  async function updateBogoPairQuantities(paidKey, freeKey, quantity) {
    const qty = parseInt(quantity, 10);
    if (!paidKey || isNaN(qty) || qty < 1) {
      throw new Error("Missing BOGO cart line keys");
    }

    const gen = cartMutationGeneration;
    const $paid = findCartLineItemEl(paidKey, null);
    const group = ($paid.attr("data-bogo-group") || "").trim();

    // /cart/change.js with the line key updates one line. /cart/update.js can
    // duplicate Pair 2 when two 1+1 deals share a variant.
    let cartData = await changeCartLineQuantity({
      lineKey: String(paidKey),
      quantity: qty,
      preferKey: true,
    });
    if (gen !== cartMutationGeneration) return cartData;

    const freeItem = findCartBogoItem(
      cartData,
      "free",
      group,
      freeKey ? String(freeKey) : null
    );
    if (
      freeItem &&
      freeItem.key &&
      String(freeItem.key) !== String(paidKey) &&
      (parseInt(freeItem.quantity, 10) || 0) !== qty
    ) {
      cartData = await changeCartLineQuantity({
        lineKey: String(freeItem.key),
        quantity: qty,
        preferKey: true,
      });
      if (gen !== cartMutationGeneration) return cartData;
    }

    return await normalizeBogoCart(cartData);
  }

  async function changeCartLineQuantity({
    lineKey,
    line,
    quantity,
    preferKey,
  }) {
    return runCartApi(async function () {
      const payload = {
        quantity: parseInt(quantity, 10),
      };

      // Removals must use the line key — line indexes shift after optimistic DOM remove.
      // Quantity changes prefer the live 1-based line index.
      if (preferKey && lineKey) {
        payload.id = lineKey;
      } else if (line) {
        payload.line = parseInt(line, 10);
      } else if (lineKey) {
        payload.id = lineKey;
      } else {
        throw new Error("Missing cart line identifier");
      }

      // JSON so quantity 0 is never dropped (form-encoding can turn delete into minus).
      return await postAjaxJson("/cart/change.js", payload);
    });
  }

  async function syncHeaderCartCount() {
    try {
      const cartData = await getAjax("/cart.js", "GET", "json");
      syncHeaderFromCart(cartData);
      return cartData;
    } catch (e) {
      return null;
    }
  }

  function syncCartPageSummaryInPlace($liveSummary, $newSummary) {
    if (
      !$liveSummary ||
      !$liveSummary.length ||
      !$newSummary ||
      !$newSummary.length
    ) {
      return false;
    }

    [
      "data-cart-page-count",
      "data-cart-page-discount",
      "data-cart-page-original-total",
      "data-cart-page-total",
    ].forEach(function (attr) {
      const $src = $newSummary.find("[" + attr + "]").first();
      const $dest = $liveSummary.find("[" + attr + "]").first();
      if (!$src.length || !$dest.length) return;
      $dest.html($src.html());
      if ($src.is("[hidden]")) {
        $dest.attr("hidden", true);
      } else {
        $dest.removeAttr("hidden");
      }
    });

    const $srcDiscountRow = $newSummary
      .find("[data-cart-page-discount-row]")
      .first();
    const $destDiscountRow = $liveSummary
      .find("[data-cart-page-discount-row]")
      .first();
    if ($srcDiscountRow.length && $destDiscountRow.length) {
      if ($srcDiscountRow.is("[hidden]")) {
        $destDiscountRow.attr("hidden", true);
      } else {
        $destDiscountRow.removeAttr("hidden");
      }
    }

    return true;
  }

  async function refreshCartPageSummary() {
    if (
      !$(".main_cart-section").length &&
      !$("[data-cart-page]").length
    ) {
      return false;
    }
    if (!$("[data-cart-summary]").length) return false;

    try {
      const root = getSectionsRootUrl();
      const sectionData = await getAjax(
        root + "cart?sections=cart&_=" + Date.now(),
        "GET",
        "json"
      );
      const sectionHtml = sectionData && sectionData.cart;
      if (!sectionHtml) return false;

      const $parsed = $("<div>").append(
        $.parseHTML(sectionHtml, document, true)
      );
      const $newSummary = $parsed.find("[data-cart-summary]").first();
      const $liveSummary = $("[data-cart-summary]").first();
      if (!$newSummary.length || !$liveSummary.length) return false;

      // Prefer in-place text updates so sticky mobile summary stays put
      if (!syncCartPageSummaryInPlace($liveSummary, $newSummary)) {
        const wasSticky = $liveSummary.hasClass("is-sticky");
        $liveSummary.replaceWith($newSummary);
        if (wasSticky) {
          $("[data-cart-summary]").addClass("is-sticky");
        }
      }

      cacheCompareAtFromDom($(".main_cart-section"));
      bindCartPageEvents();
      return true;
    } catch (error) {
      console.warn("Cart page summary refresh failed:", error);
      return false;
    }
  }

  async function refreshCartSummariesFromLiquid() {
    // Drawer (only when open — closed drawer is updated via syncCartSummariesFromCart)
    try {
      if ($("#CartDrawer").hasClass("active")) {
        await softRefreshCartDrawer(true, { preserveItems: true });
      }
    } catch (drawerError) {
      console.warn("Cart drawer summary refresh:", drawerError);
    }

    // Cart overview page summary
    try {
      if ($(".main_cart-section").length || $("[data-cart-page]").length) {
        await refreshCartPageSummary();
      }
    } catch (pageError) {
      console.warn("Cart page summary refresh:", pageError);
    }

    cacheCompareAtFromDom();
  }

  async function refreshCartPage() {
    if (!$(".main_cart-section").length) return false;

    try {
      let replaced = false;
      const root = getSectionsRootUrl();

      // 1) Section Rendering API
      try {
        const sectionData = await getAjax(
          root + "cart?sections=cart&_=" + Date.now(),
          "GET",
          "json"
        );
        const sectionHtml = sectionData && sectionData.cart;
        if (sectionHtml) {
          const $parsed = $("<div>").append(
            $.parseHTML(sectionHtml, document, true)
          );
          const $newSection = $parsed
            .find("#shopify-section-cart")
            .addBack("#shopify-section-cart")
            .first();
          if (!$newSection.length) {
            const $byClass = $parsed.find(".main_cart-section").first();
            if ($byClass.length) {
              $(".main_cart-section").html($byClass.html());
              replaced = true;
            }
          } else {
            $(".main_cart-section").html($newSection.html());
            replaced = true;
          }
        }
      } catch (sectionError) {
        console.warn("Cart section refresh failed, trying HTML fallback", sectionError);
      }

      // 2) Fallback: fetch full cart page HTML
      if (!replaced) {
        const cartUrl =
          window.location.pathname.indexOf("/cart") !== -1
            ? window.location.pathname +
              (window.location.search ? window.location.search + "&" : "?") +
              "_=" +
              Date.now()
            : root + "cart?_=" + Date.now();
        const response = await getAjax(cartUrl, "GET", "html");
        const $response = $("<div>").append(
          $.parseHTML(response, document, true)
        );
        const $src = $response.find(".main_cart-section").first();
        if ($src.length) {
          $(".main_cart-section").html($src.html());
          replaced = true;
        } else {
          const $cart = $response.find("[data-cart-page]").first();
          if ($cart.length) {
            const $live = $("[data-cart-page]");
            if ($live.length) {
              $live.replaceWith($cart);
              replaced = true;
            }
          }
        }
      }

      await syncHeaderCartCount();
      bindCartPageEvents();
      return replaced;
    } catch (error) {
      console.error("Cart page refresh:", error);
      return false;
    }
  }

  function bindCartPageEvents() {
    // Always bind via document delegation so it works after AJAX refresh
    $(document)
      .off("click.continueShopping", "[data-continue-shopping]")
      .on("click.continueShopping", "[data-continue-shopping]", function (e) {
        // Prefer previous page on this store; fallback to link href (collections)
        const fallbackHref = this.getAttribute("href") || "/";
        const referrer = document.referrer;
        if (!referrer || window.history.length <= 1) return;

        try {
          const refUrl = new URL(referrer);
          if (refUrl.origin !== window.location.origin) return;

          const refPath = refUrl.pathname.replace(/\/$/, "") || "/";
          const cartPath = (window.routes && window.routes.cart_url
            ? window.routes.cart_url
            : "/cart"
          ).replace(/\/$/, "");

          // Skip if referrer is cart itself or checkout
          if (refPath === cartPath || refPath.indexOf("/checkouts") === 0) return;

          e.preventDefault();
          e.stopPropagation();
          markCloseCartDrawerAfterContinueShopping();
          window.history.back();
        } catch (err) {
          // Keep default navigation to fallbackHref
          if (!this.getAttribute("href")) {
            window.location.href = fallbackHref;
          }
        }
      });

    $(document)
      .off("click.cartPageQty", "[data-cart-page-qty]")
      .on("click.cartPageQty", "[data-cart-page-qty]", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $btn = $(this);
        const lineKey = $btn.attr("data-line-key");
        const $item = $btn.closest(".r2b-cart__item");
        const line = $btn.attr("data-line") || $item.attr("data-line");
        const $input = $item.find(".r2b-cart__qty-input");
        let qty = parseInt($input.val(), 10);
        if (isNaN(qty)) qty = 1;
        // Pair 2 (free) qty is locked — it only follows Pair 1.
        if ($item.attr("data-bogo-role") === "free" && $item.attr("data-bogo-bundle") !== "2-plus-1") return;

        if ($item.attr("data-bogo-bundle") === "2-plus-1") {
          if ($btn.attr("data-qty-action") === "plus") return;
          if ($btn.attr("data-qty-action") === "minus") {
            const title = $.trim($item.find(".r2b-cart__item-title").text());
            const imageUrl = $item.find(".r2b-cart__item-image img").attr("src") || "";
            const productUrl = $item.find(".r2b-cart__item-title").attr("href") || "";
            openCartDrawerRemoveModal(lineKey, title, imageUrl, line, productUrl);
            return;
          }
        }

        if ($btn.attr("data-qty-action") === "plus") {
          const companion = getBogoFreeCompanionState(lineKey, line);
          let maxQty = parseInt($item.attr("data-max-qty"), 10) || 99;
          if (companion) maxQty = Math.min(maxQty, companion.maxQty);
          if (qty >= maxQty) return;
          qty += 1;
        } else {
          // Minus at 1 → show remove confirmation popup (qty would become 0)
          if (qty <= 1) {
            const title = $.trim($item.find(".r2b-cart__item-title").text());
            const imageUrl =
              $item.find(".r2b-cart__item-image img").attr("src") || "";
            const productUrl =
              $item.find(".r2b-cart__item-title").attr("href") ||
              $item.find(".r2b-cart__item-image").attr("href") ||
              "";
            openCartDrawerRemoveModal(lineKey, title, imageUrl, line, productUrl);
            return;
          }
          qty -= 1;
        }

        if (!lineKey && !line) return;

        // Instant UI — Pair 1 and linked Pair 2; API queued so rapid clicks don't stack
        const prevQty =
          parseInt($item.find(".r2b-cart__qty-input").val(), 10) || 1;
        const companion = getBogoFreeCompanionState(lineKey, line);
        applyOptimisticLineQuantity($item, qty, "page");
        applyOptimisticLineQuantity(
          findCartDrawerItem(lineKey, line),
          qty,
          "drawer"
        );
        let countDelta = qty - prevQty;
        if (companion) {
          countDelta += qty - companion.quantity;
          applyBogoFreeCompanionQuantity(companion, qty);
        }
        bumpCartItemCount(countDelta);
        enqueueCartLineUpdate(lineKey, line, qty);
      });

    $(document)
      .off("click.cartPageRemove", "[data-cart-page-remove]")
      .on("click.cartPageRemove", "[data-cart-page-remove]", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $btn = $(this);
        const lineKey = $btn.attr("data-line-key");
        const $item = $btn.closest(".r2b-cart__item");
        const line = $btn.attr("data-line") || $item.attr("data-line");
        if (!lineKey && !line) return;
        const title = $.trim($item.find(".r2b-cart__item-title").text());
        const imageUrl =
          $item.find(".r2b-cart__item-image img").attr("src") || "";
        const productUrl =
          $item.find(".r2b-cart__item-title").attr("href") ||
          $item.find(".r2b-cart__item-image").attr("href") ||
          "";
        openCartDrawerRemoveModal(lineKey, title, imageUrl, line, productUrl);
      });

    $(document)
      .off("click.cartVariantToggle", "[data-cart-variant-toggle]")
      .on("click.cartVariantToggle", "[data-cart-variant-toggle]", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $dropdown = $(this).closest("[data-cart-variant-dropdown]");
        const isOpen = $dropdown.hasClass("is-open");

        $("[data-cart-variant-dropdown].is-open").each(function () {
          closeCartVariantDropdown($(this));
        });

        if (!isOpen) {
          openCartVariantDropdown($dropdown);
        }
      });

    $(document)
      .off("click.cartVariantOption", "[data-cart-variant-option]")
      .on("click.cartVariantOption", "[data-cart-variant-option]", async function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $option = $(this);
        if ($option.is(":disabled") || $option.hasClass("is-selected")) {
          closeCartVariantDropdown($option.closest("[data-cart-variant-dropdown]"));
          return;
        }
        if (window.__r2bCartVariantBusy) return;
        window.__r2bCartVariantBusy = true;

        const $dropdown = $option.closest("[data-cart-variant-dropdown]");
        const $item = $option.closest(".r2b-cart__item");
        const lineKey = $dropdown.attr("data-line-key");
        const line = $dropdown.attr("data-line") || $item.attr("data-line");
        const quantity = parseInt($dropdown.attr("data-quantity"), 10) || 1;
        const newVariantId = $option.attr("data-variant-id");
        const label = $.trim($option.text());

        if ((!lineKey && !line) || !newVariantId) {
          window.__r2bCartVariantBusy = false;
          return;
        }

        $dropdown.find("[data-cart-variant-label]").text(label);
        closeCartVariantDropdown($dropdown);

        try {
          await changeCartPageVariant(lineKey, line, newVariantId, quantity);
          await refreshCartPage();
          await layoutUpdate(false);
        } catch (error) {
          console.error("Cart variant change:", error);
          await refreshCartPage();
        } finally {
          window.__r2bCartVariantBusy = false;
        }
      });

    $(document)
      .off("click.cartVariantOutside")
      .on("click.cartVariantOutside", function (e) {
        if (!$(e.target).closest("[data-cart-variant-dropdown]").length) {
          $("[data-cart-variant-dropdown].is-open").each(function () {
            closeCartVariantDropdown($(this));
          });
        }
      });

    initCartSummarySticky();
  }

  function initCartSummarySticky() {
    if (window._cartSummaryStickyCleanup) {
      window._cartSummaryStickyCleanup();
      window._cartSummaryStickyCleanup = null;
    }

    const summary = document.querySelector("[data-cart-summary]");
    const spacer = document.querySelector("[data-cart-summary-spacer]");
    if (!summary || !spacer) return;

    const mq = window.matchMedia("(max-width: 1024px)");
    let ticking = false;

    function releaseSticky() {
      summary.classList.remove("is-sticky");
      spacer.classList.remove("is-active");
      spacer.style.height = "";
    }

    function updateSticky() {
      if (!mq.matches) {
        releaseSticky();
        return;
      }

      const summaryHeight = summary.offsetHeight;
      if (!summaryHeight) return;

      // Measure the in-flow placeholder (spacer when sticky, otherwise the summary itself)
      const measureEl = summary.classList.contains("is-sticky") ? spacer : summary;
      const top = measureEl.getBoundingClientRect().top;
      const stickPoint = window.innerHeight - summaryHeight;
      const shouldStick = top > stickPoint;

      if (shouldStick) {
        spacer.style.height = summaryHeight + "px";
        spacer.classList.add("is-active");
        summary.classList.add("is-sticky");
      } else {
        releaseSticky();
      }
    }

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateSticky();
        ticking = false;
      });
    }

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    if (mq.addEventListener) {
      mq.addEventListener("change", onScrollOrResize);
    } else if (mq.addListener) {
      mq.addListener(onScrollOrResize);
    }

    updateSticky();

    window._cartSummaryStickyCleanup = function () {
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
      if (mq.removeEventListener) {
        mq.removeEventListener("change", onScrollOrResize);
      } else if (mq.removeListener) {
        mq.removeListener(onScrollOrResize);
      }
      releaseSticky();
    };
  }

  function openCartVariantDropdown($dropdown) {
    if (!$dropdown || !$dropdown.length) return;
    $dropdown.addClass("is-open");
    $dropdown.closest(".r2b-cart__item").addClass("is-variant-open");
    $dropdown.find("[data-cart-variant-toggle]").attr("aria-expanded", "true");
    $dropdown.find(".r2b-cart__variant-menu").removeAttr("hidden");
  }

  function closeCartVariantDropdown($dropdown) {
    if (!$dropdown || !$dropdown.length) return;
    $dropdown.removeClass("is-open");
    $dropdown.closest(".r2b-cart__item").removeClass("is-variant-open");
    $dropdown.find("[data-cart-variant-toggle]").attr("aria-expanded", "false");
    $dropdown.find(".r2b-cart__variant-menu").attr("hidden", "hidden");
  }

  function getSectionsRootUrl() {
    const root =
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      "/";
    return root.endsWith("/") ? root : root + "/";
  }

  // Swap drawer line items without wiping the whole list first. Matching lines
  // keep their price nodes so totals/prices don't flash while markup updates.
  function swapCartDrawerBodyPreservingPrices($liveBody, $newBody) {
    if (!$liveBody.length || !$newBody.length) return;

    const preservedPrices = {};
    $liveBody.find(".cart-drawer__item").each(function () {
      const $item = $(this);
      // BOGO display is role-based (not Shopify final_price) — always take fresh Liquid
      if ($item.attr("data-bogo-role")) return;
      const key = $item.attr("data-line-key");
      const $prices = $item.find(".cart-drawer__item-prices").first();
      if (key && $prices.length) {
        preservedPrices[key] = $prices.clone(false);
      }
    });

    $liveBody.html($newBody.html());

    $liveBody.find(".cart-drawer__item").each(function () {
      const $item = $(this);
      if ($item.attr("data-bogo-role")) return;
      const key = $item.attr("data-line-key");
      const $saved = key ? preservedPrices[key] : null;
      if (!$saved || !$saved.length) return;
      const $slot = $item.find(".cart-drawer__item-prices").first();
      if ($slot.length) {
        $slot.replaceWith($saved);
      }
    });
  }

  function setCartDrawerMoneyText($el, nextHtml) {
    if (!$el || !$el.length) return;
    const next = String(nextHtml == null ? "" : nextHtml);
    if ($.trim($el.html()) === $.trim(next)) return;
    $el.html(next);
  }

  // Copy summary values into the live footer instead of replaceWith — avoids
  // totals/discount "bobbing" when qty changes or items are added/removed.
  function syncCartDrawerFooterInPlace($liveFooter, $newFooter) {
    if (!$liveFooter || !$liveFooter.length || !$newFooter || !$newFooter.length) {
      return false;
    }

    const liveEmpty = $liveFooter.hasClass("cart-drawer__footer--empty");
    const newEmpty = $newFooter.hasClass("cart-drawer__footer--empty");
    const liveHasSummary = $liveFooter.find(".cart-drawer__summary").length > 0;
    const newHasSummary = $newFooter.find(".cart-drawer__summary").length > 0;

    // Structure change (empty ↔ filled) — full replace is required
    if (liveEmpty !== newEmpty || liveHasSummary !== newHasSummary) {
      return false;
    }

    $liveFooter.toggleClass(
      "cart-drawer__footer--empty",
      $newFooter.hasClass("cart-drawer__footer--empty")
    );

    [
      "data-cart-drawer-count",
      "data-cart-drawer-discount",
      "data-cart-drawer-original-total",
      "data-cart-drawer-total",
      "data-cart-drawer-subtotal",
    ].forEach(function (attr) {
      const $src = $newFooter.find("[" + attr + "]").first();
      const $dest = $liveFooter.find("[" + attr + "]").first();
      if (!$src.length || !$dest.length) return;
      setCartDrawerMoneyText($dest, $src.html());
      if ($src.is("[hidden]")) {
        $dest.attr("hidden", true);
      } else {
        $dest.removeAttr("hidden");
      }
    });

    const $srcDiscountRow = $newFooter
      .find("[data-cart-drawer-discount-row]")
      .first();
    const $destDiscountRow = $liveFooter
      .find("[data-cart-drawer-discount-row]")
      .first();
    if ($srcDiscountRow.length && $destDiscountRow.length) {
      if ($srcDiscountRow.is("[hidden]")) {
        $destDiscountRow.attr("hidden", true);
      } else {
        $destDiscountRow.removeAttr("hidden");
      }
    }

    return true;
  }

  async function softRefreshCartDrawer(forceOpen, options) {
    options = options || {};
    const wasDrawerOpen =
      forceOpen || $("#CartDrawer").hasClass("active");

    try {
      const sectionData = await getAjax(
        getSectionsRootUrl() +
          "?sections=cart-drawer&_=" +
          Date.now(),
        "GET",
        "json"
      );
      const sectionHtml = sectionData && sectionData["cart-drawer"];
      if (!sectionHtml) {
        console.warn("Cart drawer section HTML missing");
        return false;
      }

      const $parsed = $("<div>").append($.parseHTML(sectionHtml, document, true));
      const $newSection = $parsed
        .find("#shopify-section-cart-drawer")
        .addBack("#shopify-section-cart-drawer")
        .first();
      const $newDrawer = $parsed.find("#CartDrawer").first();
      const $liveDrawer = $("#CartDrawer");

      // Soft path: keep open drawer mounted — swap body/footer only (no open animation flash)
      if ($liveDrawer.length && $newDrawer.length && wasDrawerOpen) {
        $liveDrawer.addClass("cart-drawer--no-transition");

        const $newBody = $newDrawer.find("[data-cart-drawer-body]").first();
        const $liveBody = $liveDrawer.find("[data-cart-drawer-body]").first();
        if ($newBody.length && $liveBody.length && !options.preserveItems) {
          swapCartDrawerBodyPreservingPrices($liveBody, $newBody);
        } else if (
          options.preserveItems &&
          $newBody.length &&
          $liveBody.length &&
          !$liveBody.find(".cart-drawer__item").length
        ) {
          // Empty after optimistic remove — take empty markup
          $liveBody.html($newBody.html());
        }

        const $newFooter = $newDrawer.find("[data-cart-drawer-footer]").first();
        const $liveFooter = $liveDrawer.find("[data-cart-drawer-footer]").first();
        const $panel = $liveDrawer.find(".cart-drawer__panel").first();

        if ($newFooter.length) {
          if ($liveFooter.length) {
            if (!syncCartDrawerFooterInPlace($liveFooter, $newFooter)) {
              $liveFooter.replaceWith($newFooter);
            }
          } else if ($panel.length) {
            $panel.append($newFooter);
          }
        } else if ($liveFooter.length) {
          $liveFooter.remove();
        }

        $liveDrawer.addClass("active").attr("aria-hidden", "false");
        $("html").addClass("cart-drawer-active");
        bindCartDrawerEvents();

        window.requestAnimationFrame(function () {
          updateCartDrawerScrollClass();
          // Allow transitions again after paint
          setTimeout(function () {
            $liveDrawer.removeClass("cart-drawer--no-transition");
          }, 50);
        });
        cacheCompareAtFromDom($liveDrawer);
        return true;
      }

      // Closed drawer / first mount: full section replace is fine
      if ($("#shopify-section-cart-drawer").length && $newSection.length) {
        $("#shopify-section-cart-drawer").replaceWith($newSection);
      } else if ($("#CartDrawer").length && $newDrawer.length) {
        $("#CartDrawer").replaceWith($newDrawer);
      } else if ($newDrawer.length) {
        $("body").append($newDrawer);
      } else {
        return false;
      }

      cacheCompareAtFromDom($("#CartDrawer"));

      if (wasDrawerOpen) {
        const $drawer = $("#CartDrawer");
        $drawer.addClass("cart-drawer--no-transition active").attr("aria-hidden", "false");
        $("html").addClass("cart-drawer-active");
        bindCartDrawerEvents();
        window.requestAnimationFrame(function () {
          updateCartDrawerScrollClass();
          setTimeout(function () {
            $drawer.removeClass("cart-drawer--no-transition");
          }, 50);
        });
      } else {
        bindCartDrawerEvents();
      }
      return true;
    } catch (error) {
      console.error("Cart drawer refresh:", error);
      return false;
    }
  }

  async function refreshCartDrawer(forceOpen) {
    return softRefreshCartDrawer(forceOpen, { preserveItems: false });
  }

  async function showAfterAddToCart(options) {
    const {
      itemImageUrl,
      itemTitle,
      itemQty,
      itemTotalPrice,
      cartQty,
      cartTotalPrice,
      cartTotalPriceWithoutFormatedPrice,
    } = options;

    if (isCartDrawerMode()) {
      // Open drawer immediately — no full-page loader
      loading(false);
      openCartDrawer();
      await layoutUpdate(true);
      if (typeof cartQty !== "undefined") {
        window.cart.quantity = cartQty;
      }
      if (typeof cartTotalPriceWithoutFormatedPrice !== "undefined") {
        window.cart.total_price = cartTotalPriceWithoutFormatedPrice;
      }
      removeFromCartForm();
      return;
    }

    await layoutUpdate(false);

    $("#modal-addtocart .addtocart-product img").attr("src", itemImageUrl);
    $("#modal-addtocart .addtocart-product .product-title").text(itemTitle);
    $("#modal-addtocart .addtocart-product .addtocart-qty .count").text(itemQty);
    $("#modal-addtocart .product-cart-total .price-amt").text(itemTotalPrice);
    if (typeof cartQty !== "undefined") {
      $("#modal-addtocart .product-cart-price-total .modal-total-quantity").text(
        cartQty
      );
    }
    if (cartTotalPrice) {
      $("#modal-addtocart .product-cart-price-total .price").text(cartTotalPrice);
    }

    setTimeout(function () {
      if (typeof cartQty !== "undefined") {
        window.cart.quantity = cartQty;
      }
      if (typeof cartTotalPriceWithoutFormatedPrice !== "undefined") {
        window.cart.total_price = cartTotalPriceWithoutFormatedPrice;
      }
      removeFromCartForm();
      loading(false);
      $("#modal-addtocart").addClass("active");
      $("html").addClass("modal-addtocart-active");
      if ($("#modal-addtocart").hasClass("active")) {
        $(".modal-addtocart-header .close")
          .off("click.modalAtc")
          .on("click.modalAtc", function () {
            $("#modal-addtocart").removeClass("active");
            $("html").removeClass("modal-addtocart-active");
          });

        $("#modal-addtocart .modal-addtocart-overlay")
          .off("click.modalAtc")
          .on("click.modalAtc", function () {
            $("#modal-addtocart").removeClass("active");
            $("html").removeClass("modal-addtocart-active");
          });
      }
    }, 1000);
  }

  function handleResize() {
    const isTablet = $(window).innerWidth() < 1201;
    const isMobile = $(window).innerWidth() < 769;

    if (isCartDrawerMode()) {
      if (cartPopupActive) {
        $(".header-cart .dropdown-toggle").off("click", cartPopup);
        cartPopupActive = false;
        $(".header-cart .dropdown-menu").removeClass("open");
      }
      if (!headerCartDrawerBound) {
        $(document)
          .off("click.headerCartDrawer", ".header-cart .dropdown-toggle")
          .on("click.headerCartDrawer", ".header-cart .dropdown-toggle", openHeaderCartDrawer);
        headerCartDrawerBound = true;
      }
    } else if (isTablet) {
      if (headerCartDrawerBound) {
        $(document).off("click.headerCartDrawer", ".header-cart .dropdown-toggle");
        headerCartDrawerBound = false;
      }
      if (!cartPopupActive) {
        $(".header-cart .dropdown-toggle").on("click", cartPopup);
        cartPopupActive = true;
      }
    } else {
      if (headerCartDrawerBound) {
        $(document).off("click.headerCartDrawer", ".header-cart .dropdown-toggle");
        headerCartDrawerBound = false;
      }
      if (cartPopupActive) {
        $(".header-cart .dropdown-toggle").off("click", cartPopup);
        cartPopupActive = false;
        $(".header-cart .dropdown-menu").removeClass("open");
      }
    }

    if (isTablet) {
      if (!menuDrawerActive) {
        $(".header-middle-block .stackbar").on("click", menuDrawerPopup);
        menuDrawerActive = true;
      }
      if (!toggleFooterActive) {
        $(".rt-footer .toogle-section .tt-collapse-title").on(
          "click",
          toggleFooterLinks
        );
        toggleFooterActive = true;
      }

      const $lastFooterTitle = $(".rt-footer .toogle-section .tt-collapse-title").last();
      if ($lastFooterTitle.length) {
        $lastFooterTitle.addClass("tt-open");
        $lastFooterTitle.next(".tt-collapse-content").show();
      }
    } else {
      if (menuDrawerActive) {
        $(".header-middle-block .stackbar").off("click", menuDrawerPopup);
        menuDrawerActive = false;
        $(".mobile_menu").removeClass("open");
        updateMobileMenuSubOpenClass();
      }
      if (toggleFooterActive) {
        $(".rt-footer .toogle-section .tt-collapse-title").off(
          "click",
          toggleFooterLinks
        );
        toggleFooterActive = false;
        $(".rt-footer .toogle-section .tt-collapse-title").removeClass(
          "tt-open"
        );
        $(".rt-footer .toogle-section .tt-collapse-content").show();
      }
    }
  }

  $(window).on("resize", handleResize);
  handleResize();

  init();
  function init() {
    addToCartForm();
    removeFromCartForm();
    bindCartDrawerEvents();
    bindCartPageEvents();
    applyCloseCartDrawerAfterContinueShopping();
    $(window).on("pageshow.cartDrawerContinue", function () {
      applyCloseCartDrawerAfterContinueShopping();
    });
    $(document).on("keydown.cartDrawer", function (e) {
      if (e.key !== "Escape") return;
      if ($("#CartDrawerRemoveModal").hasClass("active")) {
        closeCartDrawerRemoveModal();
        return;
      }
      if ($("#CartDrawer").hasClass("active")) {
        closeCartDrawer();
      }
    });
  }

  function cartPopup(e) {
    e.preventDefault();
    $(".header-cart .dropdown-menu").toggleClass("open");
    const cartPopupOpen = $(".header-cart .dropdown-menu").hasClass("open");
    if (cartPopupOpen) {
      $(".header-cart .dropdown-menu .close").on("click", function (e) {
        e.preventDefault();
        $(".header-cart .dropdown-menu").removeClass("open");
      });
    }
  }

  function updateMobileMenuSubOpenClass() {
    const $menu = $("#menu");
    if (!$menu.length) return;
    const mobileOpen = $(".mobile_menu").hasClass("open");
    const hasActiveSub =
      $menu.find(
        ".nav__sub.is-active, .grandchild.is-active, .nav__sub-child.is-active"
      ).length > 0;
    if (mobileOpen && hasActiveSub) {
      $menu.addClass("sub-menu-open-active");
    } else {
      $menu.removeClass("sub-menu-open-active");
    }
  }

  function menuDrawerPopup(e) {
    e.preventDefault();
    $(".mobile_menu").toggleClass("open");
    const menuDrawerOpen = $(".mobile_menu").hasClass("open");
    if (menuDrawerOpen) {
      $(".mobile_menu .stackbarClose .close").on("click", function (e) {
        e.preventDefault();
        $("#menu .nav__sub, #menu .grandchild, #menu .nav__sub-child").removeClass(
          "is-active"
        );
        $(".mobile_menu").removeClass("open");
        $("html").removeClass("mobileMenuSubActive");
        updateMobileMenuSubOpenClass();
      });
    }
    updateMobileMenuSubOpenClass();
  }

  function toggleFooterLinks(event) {
    event.preventDefault();
    const target = $(event.target);
    const content = target.next(".tt-collapse-content");
    content.slideToggle();
    target.toggleClass("tt-open");
  }

  const navLinkSelector = ".custom-header .menu>ul>li > a.header-main-nav-link";
  const navItemSelector = ".custom-header .menu>ul>li.has-sub-menu";
  $(document).on("mouseenter", navLinkSelector, function () {
    $(navLinkSelector).removeClass("nav-hover-active");
    $(navItemSelector).removeClass("nav-panel-active");
    $(this).addClass("nav-hover-active");
    $(this).closest("li.has-sub-menu").addClass("nav-panel-active");
  });
 
  $(document).on("mouseleave", ".custom-header .menu>ul", function () {
    $(navItemSelector).removeClass("nav-panel-active");
    $(navLinkSelector).removeClass("nav-hover-active");
    $(navLinkSelector + ".nav-current-active").addClass("nav-hover-active");
  });
 
  if ($(".sub-menu-block.tab:not(.tab-click) ul.tabs li").length > 0) {
    $(".sub-menu-block.tab:not(.tab-click) ul.tabs li").hover(function () {
      var tab_id = $(this).attr("data-tab");
      $(".sub-menu-block.tab:not(.tab-click) ul.tabs li").removeClass("current");
      $(".sub-menu-block.tab:not(.tab-click) .tab-content").removeClass("current");
      $(this).addClass("current");
      $(".sub-menu-block.tab:not(.tab-click) #" + tab_id).addClass("current");
    });
  }

  if ($(".sub-menu-block.tab.tab-click ul.tabs li").length > 0) {
    $(".sub-menu-block.tab.tab-click ul.tabs li").on("click", function (e) {
      e.preventDefault();
      var tab_id = $(this).attr("data-tab");
      $(".sub-menu-block.tab.tab-click ul.tabs li").removeClass("current");
      $(".sub-menu-block.tab.tab-click .tab-content").removeClass("current");
      $(this).addClass("current");
      $(".sub-menu-block.tab.tab-click #" + tab_id).addClass("current");
    });
  }

  if ($(".mobile_menu .sub-menu-block.tab ul.tabs li").length > 0) {
    $(".mobile_menu .sub-menu-block.tab ul.tabs li").on("click", function (e) {
      e.preventDefault();
      var $tabBlock = $(this).closest(".sub-menu-block.tab");
      var tab_id = $(this).attr("data-tab");
      $tabBlock.find("ul.tabs li").removeClass("current");
      $tabBlock.find(".tab-content").removeClass("current");
      $(this).addClass("current");
      $tabBlock.find("#" + tab_id).addClass("current");
    });
  }

  if ($(".mobile_menu .combined-device-tabs .combined-device-tab-link").length > 0) {
    $(".mobile_menu .combined-device-tabs .combined-device-tab-link").on(
      "click",
      function (e) {
        e.preventDefault();
        var $wrapper = $(this).closest(".combined-device-wrapper");
        var tab_id = $(this).attr("data-inner-tab");

        $wrapper.find(".combined-device-tab-link").removeClass("current");
        $wrapper.find(".combined-device-content").removeClass("current");

        $(this).addClass("current");
        $wrapper.find("#" + tab_id).addClass("current");
      }
    );
  }

  $(document).on("click", ".sub__close", function (event) {
    event.preventDefault();
    $(this).closest("ul.nav__sub").removeClass("is-active");
    if ($("#menu ul.nav__sub.is-active").length === 0) {
      $("html").removeClass("mobileMenuSubActive");
    }
    updateMobileMenuSubOpenClass();
  });

  $(document).on("click", ".mobileMenuBack", function (event) {
    event.preventDefault();
    const $activeSubMenu = $("#menu ul.nav__sub.is-active").last();
    if ($activeSubMenu.length) {
      $activeSubMenu.removeClass("is-active");
    }

    if ($("#menu ul.nav__sub.is-active").length === 0) {
      $("html").removeClass("mobileMenuSubActive");
    }
    updateMobileMenuSubOpenClass();
  });

  $(document).on("click", ".mobile-mega-panel__close", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("#menu .nav__sub, #menu .grandchild, #menu .nav__sub-child").removeClass(
      "is-active"
    );
    $(".mobile_menu").removeClass("open");
    $("html").removeClass("mobileMenuActive");
    $("html").removeClass("mobileMenuSubActive");
    updateMobileMenuSubOpenClass();
  });

  $(document).on("click", "#menu a", function (event) {
    const subMenu = $(this).next(".nav__sub");
    if (subMenu && subMenu.length) {
     event.preventDefault();
      subMenu.addClass("is-active");
       $("html").addClass("mobileMenuSubActive");
      updateMobileMenuSubOpenClass();
    }
  });

  $(".has-dropdown").on("click", function () {
    const submenu = $(this).find(".submenu");
    if (submenu.length) {
      submenu.toggle();
    }
  });

  let desktop_menu = $(".desktop_menu");
  let stickyHeader = desktop_menu.offset().top;
  function handleScroll() {
    if ($(window).scrollTop() >= stickyHeader) {
      desktop_menu.addClass("sticky");
    } else {
      desktop_menu.removeClass("sticky");
    }
  }
  $(window).scroll(handleScroll);

  function resolveSelectedVariantId(formEl) {
    try {
      if (!formEl) return null;

      const card = formEl.closest(".rt-product-card");
      if (card) {
        const cardChecked = card.querySelector(
          '.tt-options-swatch input[type="radio"]:checked'
        );
        const cardVarId = cardChecked?.getAttribute("var_id");
        if (cardVarId) return cardVarId.toString();
      }

      const productMain = document.querySelector(".product-main");
      if (productMain && window.productJson) {
        const variants = JSON.parse(window.productJson);
        const selectedValues = [];
        const requiredOptionIdxs = new Set();
        const mainSwatchInputs = Array.from(
          productMain.querySelectorAll('.tt-options-swatch input[type="radio"]')
        ).filter(
          (input) =>
            !input.closest(".rt-product-card") &&
            !input.closest("[data-bogo-pair-options]") &&
            !input.hasAttribute("data-bogo-pair")
        );

        mainSwatchInputs.forEach((el) => {
          const optionIndex = el.getAttribute("optionIndex");
          if (!optionIndex) return;
          const idx = parseInt(optionIndex.replace("option", ""), 10) - 1;
          if (!Number.isNaN(idx) && idx >= 0 && idx < 3) {
            requiredOptionIdxs.add(idx);
          }
        });

        mainSwatchInputs
          .filter((input) => input.checked)
          .forEach((input) => {
            const optionIndex = input.getAttribute("optionIndex");
            const value = (input.value || "").toString();
            if (!value) return;
            if (optionIndex) {
              const idx = parseInt(optionIndex.replace("option", ""), 10) - 1;
              if (!Number.isNaN(idx) && idx >= 0 && idx < 3) {
                selectedValues[idx] = value;
              }
            }
          });

        for (const idx of requiredOptionIdxs) {
          if (!selectedValues[idx]) return null;
        }

        const normalize = (str) => (str || "").toString().trim().toLowerCase();
        const matchingVariant = variants.find((v) => {
          if (selectedValues[0] && normalize(v.option1) !== normalize(selectedValues[0])) return false;
          if (selectedValues[1] && normalize(v.option2) !== normalize(selectedValues[1])) return false;
          if (selectedValues[2] && normalize(v.option3) !== normalize(selectedValues[2])) return false;
          return true;
        });
        if (matchingVariant?.id) return matchingVariant.id.toString();
      }

      const currentInputValue = formEl.querySelector('input[name="id"]')?.value;
      return currentInputValue ? currentInputValue.toString() : null;
    } catch (e) {
      const fallbackValue = formEl?.querySelector('input[name="id"]')?.value;
      return fallbackValue ? fallbackValue.toString() : null;
    }
  }

  // Prevent duplicate /cart/add.js from double-clicks or stacked handlers
  let addToCartInFlight = false;

  function beginAddToCart($form) {
    if (addToCartInFlight || window.__r2bAddToCartBusy) return false;
    addToCartInFlight = true;
    window.__r2bAddToCartBusy = true;
    if ($form && $form.length) {
      $form.data("atc-busy", true);
      $form
        .find('button[type="submit"], .sticky-atc-btn, .btn[type="submit"]')
        .prop("disabled", true)
        .attr("aria-busy", "true");
    }
    $(".sticky-atc-btn").prop("disabled", true).attr("aria-busy", "true");
    return true;
  }

  function endAddToCart($form) {
    addToCartInFlight = false;
    window.__r2bAddToCartBusy = false;
    if ($form && $form.length) {
      $form.data("atc-busy", false);
      $form
        .find('button[type="submit"], .btn[type="submit"]')
        .prop("disabled", false)
        .removeAttr("aria-busy");
    }
    $(".sticky-atc-btn").prop("disabled", false).removeAttr("aria-busy");
  }

  function getFormAddQuantity($form) {
    const $qty = $form.find(".qty-value, .sticky-qty-value, [name='quantity']").first();
    const qty = parseInt($qty.val(), 10);
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }
  // R2B BOGO 2+1 - one cart flow for the main and sticky forms.
  async function addBogo2Plus1ToCart($form) {
    if ($form.data("atc-busy") || !beginAddToCart($form)) return;
    try {
      const api = window.R2BBogo2Plus1;
      if (!api || typeof api.getCartItems !== "function") {
        throw new Error("Het 2+1-keuzescript is niet geladen. Vernieuw de pagina.");
      }
      const payload = api.getCartItems();
      if (!payload || !Array.isArray(payload.items) || payload.items.length !== 3) {
        // The choices script displays its own per-pair validation message.
        return;
      }
      const valid = payload.items.every(function (item) {
        return /^\d+$/.test(String(item.id)) && Number(item.quantity) === 1;
      });
      if (!valid) throw new Error("Een van de gekozen varianten heeft geen geldig variantnummer.");

      if (!isCartDrawerMode()) loading(true);
      const response = await postAjaxJson("/cart/add.js", payload);
      const cart = await getAjax("/cart.js", "GET", "json");
      const added = Array.isArray(response.items) ? response.items : (response.id ? [response] : []);
      const first = added[0] || {};
      const itemQty = payload.items.reduce(function (sum, item) {
        return sum + (Number(item.quantity) || 0);
      }, 0);
      // Shopify's actual cart total is authoritative; do not fabricate a discount.
      const itemTotal = added.reduce(function (sum, item) {
        return sum + Number(item.final_line_price != null ? item.final_line_price :
          (Number(item.final_price != null ? item.final_price : item.price) || 0) * (Number(item.quantity) || 1));
      }, 0);
      await showAfterAddToCart({
        itemImageUrl: (first.featured_image && first.featured_image.url) || "",
        itemTitle: first.title || "3 paar compressiekousen",
        itemQty: itemQty,
        itemTotalPrice: getItemFormatedPrice(itemTotal),
        cartQty: cart.item_count,
        cartTotalPrice: getItemFormatedPrice(cart.total_price),
        cartTotalPriceWithoutFormatedPrice: cart.total_price
      });
    } catch (error) {
      console.error("R2B BOGO 2+1 toevoegen:", error);
      loading(false);
      alert("Toevoegen van 2+1 mislukt: " +
        (error && (error.responseJSON && (error.responseJSON.description || error.responseJSON.message) || error.message) || "Probeer het opnieuw."));
    } finally {
      endAddToCart($form);
    }
  }

  function addToCartForm() {
    // Delegated once — survives collection re-renders without stacking handlers
    $(document)
      .off("submit.globalAtc", ".add-to-cart-form")
      .on("submit.globalAtc", ".add-to-cart-form", async function (event) {
        event.preventDefault();
        event.stopPropagation();
        // Recommendations use submit.r2bRec — don't handle twice
        if ($(this).closest(".product-recommendations").length > 0) return;

        const $form = $(this);
        // R2B custom bundle: let the dedicated bundle handler add the
        // main product + all selected add-ons in one Shopify request.
        // Restrict this to the real PDP form so collection/recommendation
        // add-to-cart buttons can never accidentally reuse a PDP bundle selection.
        const isMainPdpForm =
          this.id === "product-form-atc" ||
          this.id === "product-form-atc-ctm" ||
          $form.closest(".product-main").length > 0;
        // Only the real 2+1 product page uses the three-pair cart payload.
        if (isMainPdpForm && document.querySelector("[data-bogo-2-plus-1-options]")) {
          event.stopImmediatePropagation();
          await addBogo2Plus1ToCart($form);
          return;
        }

        const hasR2bBundle =
          isMainPdpForm &&
          Array.isArray(window.bundleSelectedProducts) &&
          window.bundleSelectedProducts.length > 0;

        if (hasR2bBundle && typeof window.r2bSubmitWithBundle === "function") {
          event.stopImmediatePropagation();
          const triggerBtn =
            $form.find('button[type="submit"]').get(0) ||
            document.querySelector("#originalAtcWrapper button[type='submit']");
          window.r2bSubmitWithBundle(this, triggerBtn);
          return;
        }

        if ($form.data("atc-busy") || !beginAddToCart($form)) return;

        try {
          const isBogoForm =
            $form.hasClass("bogo-1-plus-1-form") ||
            $form.find("[data-bogo-1-plus-1]").length > 0;

          if (isBogoForm) {
            if (!window.R2BBogo || typeof window.R2BBogo.getCartItems !== "function") {
              console.error("BOGO add-to-cart: R2BBogo is not ready");
              return;
            }

            const bogoPayload = window.R2BBogo.getCartItems();
            if (!bogoPayload || !bogoPayload.items || !bogoPayload.items.length) {
              return;
            }

            if (!isCartDrawerMode()) {
              loading(true);
            }

            const response = await postAjaxJson("/cart/add.js", bogoPayload);
            const items = Array.isArray(response.items)
              ? response.items
              : response.id
                ? [response]
                : [];
            const firstItem = items[0] || response;
            const itemImageUrl =
              firstItem.featured_image && firstItem.featured_image.url
                ? firstItem.featured_image.url
                : "";
            const itemTitle = firstItem.title || "";
            const itemQty = bogoPayload.items.reduce(function (sum, item) {
              return sum + (parseInt(item.quantity, 10) || 0);
            }, 0);
            const paidPrice = items.reduce(function (sum, item) {
              const role =
                item.properties &&
                (item.properties._bogo_role || item.properties["_bogo_role"]);
              if (role === "free") return sum;
              return (
                sum +
                (parseInt(item.price, 10) || 0) *
                  (parseInt(item.quantity, 10) || 1)
              );
            }, 0);
            const itemTotalPrice = getItemFormatedPrice(paidPrice);
            const cartQty = parseInt(window.cart.quantity, 10) + itemQty;
            const cartTotalPriceWithoutFormatedPrice =
              parseInt(window.cart.total_price, 10) + paidPrice;
            const cartTotalPrice = getItemFormatedPrice(
              cartTotalPriceWithoutFormatedPrice
            );
            await showAfterAddToCart({
              itemImageUrl,
              itemTitle,
              itemQty,
              itemTotalPrice,
              cartQty,
              cartTotalPrice,
              cartTotalPriceWithoutFormatedPrice,
            });
            return;
          }

          const resolvedVariantId = resolveSelectedVariantId(this);
          if (resolvedVariantId) {
            $form.find('input[name="id"]').val(resolvedVariantId);
          }
          if (!isCartDrawerMode()) {
            loading(true);
          }
          const addQty = getFormAddQuantity($form);
          const response = await postAjax(
            "/cart/add.js",
            "POST",
            "json",
            $form.serialize()
          );
          const itemImageUrl =
            response.featured_image && response.featured_image.url
              ? response.featured_image.url
              : "";
          const itemTitle = response.title;
          const itemQty = addQty;
          const itemTotalPrice = getItemFormatedPrice(response.price * itemQty);
          const cartQty = parseInt(window.cart.quantity, 10) + itemQty;
          const cartTotalPriceWithoutFormatedPrice =
            parseInt(window.cart.total_price, 10) +
            parseInt(response.price, 10) * itemQty;
          const cartTotalPrice = getItemFormatedPrice(
            cartTotalPriceWithoutFormatedPrice
          );
          await showAfterAddToCart({
            itemImageUrl,
            itemTitle,
            itemQty,
            itemTotalPrice,
            cartQty,
            cartTotalPrice,
            cartTotalPriceWithoutFormatedPrice,
          });
        } catch (error) {
          console.error("Add to cart:", error);
          loading(false);
        } finally {
          endAddToCart($form);
        }
      });
    onChangeQty();
  }

  async function postAjaxJson(url, data) {
    return await $.ajax({
      type: "POST",
      url: url,
      data: JSON.stringify(data),
      contentType: "application/json",
      dataType: "json",
    });
  }

  function removeFromCartForm() {
    $(".header_delete_cartitem_js").click(async function (event) {
      event.preventDefault();
      const href = $(this).attr("href");
      const urlParams = new URLSearchParams(href.split("?")[1]);
      var cartUpdates = {};
      cartUpdates[urlParams.get("id")] = parseInt(urlParams.get("quantity"));
      try {
        const response = await postAjax("/cart/update.js", "POST", "json", {
          updates: cartUpdates,
        });
        await layoutUpdate();
        setTimeout(function () {
          removeFromCartForm();
        }, 1000);
      } catch (error) {
        console.error("Error loading more content:", error);
        loading(false);
      }
    });
  }

  function onChangeQty() {
    $(".qty-wrapper .qty-btn")
      .off("click.productQty")
      .on("click.productQty", function () {
      const inputQty = $(this).parent().find("input.qty-input_box");
      const currentQty = parseInt(inputQty.val());
      if ($(this).hasClass("plus-btn")) {
        inputQty.val(Math.max(currentQty + 1, 1));
      } else {
        inputQty.val(Math.max(currentQty - 1, 1));
      }
    });
  }

  async function postAjax(url, method, dataType, data) {
    const params = {
      type: method,
      url: url,
      data: data,
      dataType: dataType,
      traditional: true,
    };
    return await $.ajax(params);
  }

  async function getAjax(url, method, dataType) {
    const params = {
      type: method,
      url: url,
      dataType: dataType,
      cache: false,
    };
    const response = await $.ajax(params);
    return response;
  }

  async function layoutUpdate(forceOpenDrawer) {
    try {
      // Soft drawer refresh — keeps open state without slide/fade flash
      await softRefreshCartDrawer(!!forceOpenDrawer);

      try {
        const cartData = await getAjax("/cart.js", "GET", "json");
        syncHeaderFromCart(cartData);
      } catch (cartError) {}

      removeFromCartForm();
    } catch (error) {
      console.error("Error loading more content:", error);
      loading(false);
    }
  }

  async function cartlayoutUpdate(data) {
    try {
      await postAjax("/cart/update.js", "POST", "json", data);
      await refreshCartPage();
      await refreshCartDrawer($("#CartDrawer").hasClass("active"));

      try {
        const cartData = await getAjax("/cart.js", "GET", "json");
        window.cart.quantity = cartData.item_count;
        window.cart.total_price = cartData.items_subtotal_price;
        $(".header-cart .badge-cart").text(cartData.item_count);
      } catch (cartError) {}

      bindCartPageEvents();
      loading(false);
    } catch (error) {
      console.error("Error loading more content:", error);
      loading(false);
    }
  }

  if (
    $("body").hasClass("pagecollection") ||
    $("body").hasClass("pagesearch")
  ) {
    filterLoad();
    function filterLoad() {
      if (".pagecollection .filter-title") {
        $(".pagecollection .filter-title").click(function (e) {
          e.preventDefault();
          $(this).toggleClass("active");
          $(this).next(".filter-content").slideToggle();
        });
      }

      $(".filters-options .btn-toggle").click(function () {
        $("#filter-sidebar").addClass("filter-active");
        $("html").addClass("filter--active");
      });
      $(".filter-mobile-header").click(function () {
        $("#filter-sidebar").removeClass("filter-active");
        $("html").removeClass("filter--active");
      });
    }

    function updateItemView() {
      const isMobile = $(window).innerWidth() < 769;
      const currentView = localStorage.getItem("item_view");

      if (isMobile) {
        if (currentView !== "list") {
          localStorage.setItem("item_view", "list");
        }
      } else {
        if (currentView !== "grid") {
          localStorage.setItem("item_view", "grid");
        }
      }

      if (localStorage.getItem("item_view") == "list") {
        listView();
      }
      if (localStorage.getItem("item_view") == "grid") {
        gridView();
      }
      $(".collection-main__wrapper .quantity.view .col-one").click(function (
        e
      ) {
        e.preventDefault();
        if (localStorage.getItem("item_view") == "grid") {
          loading(true);
          setTimeout(function () {
            localStorage.setItem("item_view", "list");
            listView();
          }, 1500);
        }
      });
      $(".collection-main__wrapper .quantity.view .col-three").click(function (
        e
      ) {
        e.preventDefault();
        if (localStorage.getItem("item_view") == "list") {
          loading(true);
          setTimeout(function () {
            localStorage.setItem("item_view", "grid");
            gridView();
          }, 1500);
        }
      });
    }
    function gridView() {
      $(".collection-main__wrapper .quantity.view .col-three").addClass(
        "active"
      );
      $(".collection-main__wrapper .quantity.view .col-one").removeClass(
        "active"
      );
      $(".products").removeClass("list").addClass("grid");
      $(".products .col-item").removeClass("col-md-12").addClass("col-md-6");
      $(".products .col-item").removeClass("col-12").addClass("col-6");
      loading(false);
    }
    function listView() {
      $(".collection-main__wrapper .quantity.view .col-one").addClass("active");
      $(".collection-main__wrapper .quantity.view .col-three").removeClass(
        "active"
      );
      $(".products").removeClass("grid").addClass("list");
      $(".products .col-item").removeClass("col-md-6").addClass("col-md-12");
      $(".products .col-item").removeClass("col-6").addClass("col-12");
      loading(false);
    }

    function updateURLParameter(url, newKey, newValue) {
      let urlObj = new URL(url);
      urlObj.searchParams.set(newKey, newValue);
      return urlObj.toString();
    }

    function replaceCollectionJsonLd(html) {
      if (!html || typeof html !== "string") return;
      var parsed = new DOMParser().parseFromString(html, "text/html");
      ["CollectionItemListJsonLd"].forEach(function (id) {
        var next = parsed.getElementById(id);
        var current = document.getElementById(id);
        if (!next || !current) return;
        current.textContent = next.textContent;
        current.removeAttribute("data-trustbadge-jsonld");
      });
    }

    updateItemView();
    $("select.sort-position").on("change", async function (event) {
      loading(true);
      let selectedValue = $(this).val();
      let newUrl = updateURLParameter(
        window.location.href,
        "sort_by",
        selectedValue
      );
      try {
        let productRes = await getAjax(newUrl, "GET", "html");
        let gridUpdate = $(productRes).find(".products").html();
        $(".products").html(gridUpdate);
        replaceCollectionJsonLd(productRes);
        updateItemView();
        addToCartForm();
        onChangeVariantPLP();
        window.history.pushState({ path: newUrl }, "", newUrl);
        loading(false);
      } catch (error) {
        console.error("Error loading more content:", error);
        loading(false);
      }
    });

    function onChangeVariantPLP() {
      if ($(".tt-swatches-container").length > 0) {
        $('.tt-options-swatch input[type="radio"]')
          .off("change.plpVariant")
          .on("change.plpVariant", function () {
            let var_id = $(this).attr("var_id");
            $(this)
              .closest(".rt-product-card__details")
              .find('.add-to-cart-form [name="id"]')
              .val(var_id);

            if (
              typeof Globo != "undefined" &&
              typeof Globo?.Preorder != "undefined"
            ) {
              $(this)
                .closest(".card-bottom-desc")
                ?.find("form.gridProductPreOrderForm.preorderLoaded")
                ?.removeClass("preorderLoaded");
              Globo?.Preorder?.initCollection();
            }
          });
      }
    }

    onChangeVariantPLP();
    if ($('.collection-main__wrapper .rt-collection-products.infinite_scroll').length > 0) {
      new Ajaxinate({
        container: '#Huratips-Loop',
        pagination: '#Huratips-Pagination'
      });
    }

    removeFilter();
    $(".facets-form").change(function () {
      $(this).submit();
    });

    $(".facets-form").submit(async function (event) {
      event.preventDefault();
      var formData = $(this).serialize();
      var newUrl =
        window.location.origin + window.location.pathname + "?" + formData;

      try {
        loading(true);
        const productRes = await getAjax(newUrl, "GET", "html");
        let gridUpdate = $(productRes).find(".products").html();
        $(".products").html(gridUpdate);
        replaceCollectionJsonLd(productRes);
        let facetsForm = $(productRes).find(".facets-form").html();
        $(".facets-form").html(facetsForm);
        history.replaceState(null, null, newUrl);
        updateItemView();
        addToCartForm();
        onChangeVariantPLP();
        filterLoad();
        removeFilter();
        loading(false);
      } catch (error) {
        console.error("Error loading more content:", error);
        loading(false);
      }
    });

    function removeFilter() {
      if ($(".facets-form .selected-all .selected-filter").length > 1) {
        $(".facets-form .selected-all .selected-filter.clear_all").show();
      } else {
        $(".facets-form .selected-all .selected-filter.clear_all").hide();
      }
      $(".facets-form .selected-filter a").click(async function (e) {
        e.preventDefault();
        const linkUrl = window.location.origin + $(this).attr("href");

        try {
          loading(true);
          let productRes = await getAjax(linkUrl, "GET", "html");
          let gridUpdate = $(productRes).find(".products").html();
          $(".products").html(gridUpdate);
          replaceCollectionJsonLd(productRes);
          let facetsForm = $(productRes).find(".facets-form").html();
          $(".facets-form").html(facetsForm);

          history.replaceState(null, null, linkUrl);
          updateItemView();
          addToCartForm();
          filterLoad();
          removeFilter();
          onChangeVariantPLP();
          loading(false);
        } catch {
          console.error("Error loading more content:", error);
          loading(false);
        }
      });
    }
  }

  if ($("body").hasClass("pagecart")) {
    bindCartPageEvents();
  }

  // Match default product AND alternate templates (e.g. product.bogo-1-plus-1 → class "pageproduct.bogo-1-plus-1")
  var isProductPage =
    $("body").hasClass("pageproduct") ||
    $("body").hasClass("template--product") ||
    ($("body").attr("class") || "").indexOf("pageproduct") !== -1 ||
    document.querySelector(".product-main");

  if (isProductPage) {
    pdpJS();
    window.updateBundleSlider = function() {
      const bundleSection = document.querySelector('.product-bundle-section');
      if (!bundleSection) {
        return;
      }
      
      const slider = bundleSection.querySelector('.bundle-products-slider');
      if (!slider) {
        return;
      }
      
      const sliderEnabledAttr = slider.getAttribute('data-slider-enabled');
      const sliderEnabled = sliderEnabledAttr === 'true' || sliderEnabledAttr === true;
      if (!sliderEnabled) {
        return;
      }
      
      if (slider.classList.contains('slick-initialized')) {
        if (typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn.slick !== 'undefined') {
          try {
            window.jQuery(slider).slick('unslick');
          } catch(e) {
            console.warn('Bundle: Error destroying slider:', e);
          }
        }
        slider.classList.remove('slick-initialized');
        slider.removeAttribute('style');
        const slickTrack = slider.querySelector('.slick-track');
        if (slickTrack) {
          const slides = slickTrack.querySelectorAll('.slick-slide');
          slides.forEach(function(slide) {
            slide.classList.remove('slick-slide');
            slide.removeAttribute('style');
            slide.removeAttribute('data-slick-index');
          });
          slickTrack.remove();
        }
      }
      
      setTimeout(function() {
        const slickOptions = {
          arrows: true,
          prevArrow: bundleSection.querySelector('.bundle-slider-prev'),
          nextArrow: bundleSection.querySelector('.bundle-slider-next'),
          slidesToShow: 2.5,
          slidesToScroll: 1,
          infinite: false,
          draggable: true,
          swipe: true,
          touchMove: true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1
              }
            }
          ]
        };
        
        if (typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn.slick !== 'undefined') {
          try {
            window.jQuery(slider).slick(slickOptions);
          } catch(e) {
            console.warn('Bundle: Error initializing slider:', e);
          }
        } else {
          console.warn('Bundle: jQuery or Slick not available');
        }
      }, 300);
    };

    function bindSwatchLabelClickFallback() {
      $(document)
        .off(
          "click.r2bSwatchLabel",
          ".tt-options-swatch .swatch-input__label, .variant-drawer-option-label"
        )
        .on(
          "click.r2bSwatchLabel",
          ".tt-options-swatch .swatch-input__label, .variant-drawer-option-label",
          function (e) {
            if ($(this).closest("[data-bogo-pair-options]").length > 0) return;

            const input = this.previousElementSibling;
            if (!input || input.tagName !== "INPUT" || input.type !== "radio") {
              return;
            }
            if (input.disabled) {
              e.preventDefault();
              return;
            }
            if (!input.checked) {
              e.preventDefault();
              input.checked = true;
              input.setAttribute("checked", "checked");
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        );
    }

    function syncCheckedAttributeForSwatches() {
      $(document)
        .off("change.r2bCheckedAttr", '.tt-options-swatch input[type="radio"]')
        .on("change.r2bCheckedAttr", '.tt-options-swatch input[type="radio"]', function () {
          const changedInput = this;
          if (
            changedInput.closest("[data-bogo-pair-options]") ||
            changedInput.hasAttribute("data-bogo-pair")
          ) {
            return;
          }
          const card = changedInput.closest(".rt-product-card");
          const swatchRoot =
            changedInput.closest(".tt-swatches-container") ||
            changedInput.closest(".product-main") ||
            document;
          const optionIndex = changedInput.getAttribute("optionIndex");
          const name = changedInput.getAttribute("name");

          let groupSelector = null;
          if (optionIndex) {
            groupSelector = `.tt-options-swatch input[type="radio"][optionIndex="${optionIndex}"]`;
          } else if (name) {
            groupSelector = `.tt-options-swatch input[type="radio"][name="${name.replace(/"/g, '\\"')}"]`;
          }
          if (!groupSelector) return;

          const scope = card || swatchRoot;
          const radios = scope.querySelectorAll(groupSelector);
          radios.forEach((radio) => {
            if (radio.closest("[data-bogo-pair-options]")) return;
            const label =
              radio.nextElementSibling &&
              radio.nextElementSibling.tagName === "LABEL"
                ? radio.nextElementSibling
                : document.querySelector('label[for="' + radio.id + '"]');
            if (radio === changedInput && radio.checked) {
              radio.setAttribute("checked", "checked");
              if (label) {
                label.classList.add("variant-option-checked");
                if (label.classList.contains("swatch-color-option")) {
                  label.classList.add("swatch-checked");
                }
              }
            } else {
              radio.removeAttribute("checked");
              if (label) {
                label.classList.remove("swatch-checked", "variant-option-checked");
              }
            }
          });
        });
    }

    function isBogoPairControl(el) {
      if (!el) return false;
      return !!(
        el.closest &&
        (el.closest("[data-bogo-pair-options]") ||
          el.hasAttribute("data-bogo-pair"))
      );
    }

    function getMainPdpSwatchInputs(productMainEl) {
      return Array.from(
        productMainEl.querySelectorAll('.tt-options-swatch input[type="radio"]')
      ).filter(
        (input) =>
          !input.closest(".rt-product-card") && !isBogoPairControl(input)
      );
    }

    function goToVariantMedia(varId) {
      try {
        if (!window.productJson || !varId) return;
        const variants = JSON.parse(window.productJson);
        const variant = variants.find(
          (v) => String(v.id) === String(varId)
        );
        if (!variant) return;

        const mediaId =
          (variant.featured_media && variant.featured_media.id) ||
          (variant.featured_image && variant.featured_image.id);
        if (!mediaId) return;

        const $slider = $(".slider-for");
        if (!$slider.length || !$slider.hasClass("slick-initialized")) return;

        let targetIndex = -1;
        $slider.find(".slick-slide:not(.slick-cloned)").each(function () {
          const slideMediaId =
            this.getAttribute("data-media-id") ||
            (this.querySelector("[data-media-id]") &&
              this.querySelector("[data-media-id]").getAttribute("data-media-id"));
          if (slideMediaId && String(slideMediaId) === String(mediaId)) {
            const slickIndex = $(this).data("slick-index");
            targetIndex =
              typeof slickIndex === "number" ? slickIndex : targetIndex;
            return false;
          }
        });

        if (targetIndex >= 0) {
          $slider.slick("slickGoTo", targetIndex, true);
        }
      } catch (e) {
        console.warn("Variant media sync skipped:", e);
      }
    }

    function updatePdpPriceFromVariant(varId) {
      try {
        if (!window.productJson || !varId) return;
        const variants = JSON.parse(window.productJson);
        const variant = variants.find(
          (v) => String(v.id) === String(varId)
        );
        if (!variant) return;

        const priceCurrent = document.querySelector(
          "#product-price-current, .bundle-current-price, .product-price-current"
        );
        if (priceCurrent && typeof variant.price === "number") {
          const formatted = new Intl.NumberFormat("nl-NL", {
            style: "currency",
            currency: (window.shop && window.shop.currencyCode) || "EUR",
          }).format(variant.price / 100);
          priceCurrent.textContent = formatted;
          priceCurrent.setAttribute("data-current-price", String(variant.price));
        }

        const priceCompare = document.querySelector(
          "#product-price-compare, .bundle-original-price, .product-price-compare"
        );
        if (priceCompare) {
          if (
            variant.compare_at_price &&
            variant.compare_at_price > variant.price
          ) {
            const formattedCompare = new Intl.NumberFormat("nl-NL", {
              style: "currency",
              currency: (window.shop && window.shop.currencyCode) || "EUR",
            }).format(variant.compare_at_price / 100);
            priceCompare.textContent = formattedCompare;
            priceCompare.style.display = "";
          } else {
            priceCompare.style.display = "none";
          }
        }
      } catch (e) {
        console.warn("Variant price sync skipped:", e);
      }
    }

    function applyPdpVariantChange(varId) {
      if (!varId) return false;

      const formSelectors = [
        '.pdp-cart-form .add-to-cart-form [name="id"]',
        '#product-form-atc [name="id"]',
        '#product-form-atc-ctm [name="id"]',
        '.product-main .pdp-cart-form form [name="id"]',
        '#bottom-sticky-cta-section form [name="id"]',
      ];

      formSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((input) => {
          input.value = String(varId);
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });

      try {
        const urlObj = new URL(window.location.href);
        urlObj.searchParams.set("variant", String(varId));
        window.history.replaceState({ path: urlObj.toString() }, "", urlObj.toString());
      } catch (e) {}

      goToVariantMedia(varId);
      updatePdpPriceFromVariant(varId);

      window.dispatchEvent(
        new CustomEvent("variant:change", { detail: { variantId: String(varId) } })
      );
      return true;
    }

    window.R2BApplyVariantChange = applyPdpVariantChange;

    function onChangeVariant() {
      const productMainEl = document.querySelector(".product-main");
      if (!productMainEl) return;

      $(productMainEl)
        .off("change.pdpVariant")
        .on(
          "change.pdpVariant",
          '.tt-options-swatch input[type="radio"]',
          async function () {
            if ($(this).closest(".rt-product-card").length > 0) return;
            if (isBogoPairControl(this)) return;

            function isValidVariantId(id) {
              return (
                id &&
                id !== "undefined" &&
                id !== "null" &&
                (typeof id !== "string" || id.trim() !== "")
              );
            }

            const mainVariantInput = document.querySelector(
              ".pdp-cart-form .add-to-cart-form [name=\"id\"]"
            );

            function getSelectedVariantIdFromOptions() {
              try {
                if (!window.productJson) return null;
                const variants = JSON.parse(window.productJson);
                const selectedValues = [];
                const requiredOptionIdxs = new Set();

                const mainPdpSwatches = getMainPdpSwatchInputs(productMainEl);

                mainPdpSwatches.forEach((el) => {
                  const optionIndex = el.getAttribute("optionIndex");
                  if (!optionIndex) return;
                  const idx = parseInt(
                    optionIndex.replace("option", ""),
                    10
                  ) - 1;
                  if (!Number.isNaN(idx) && idx >= 0 && idx < 3) {
                    requiredOptionIdxs.add(idx);
                  }
                });

                mainPdpSwatches
                  .filter((input) => input.checked)
                  .forEach((input) => {
                    const optionIndex = input.getAttribute("optionIndex");
                    const value = (input.value || "").toString();
                    if (!value) return;

                    if (optionIndex) {
                      const idx = parseInt(
                        optionIndex.replace("option", ""),
                        10
                      ) - 1;
                      if (!Number.isNaN(idx) && idx >= 0 && idx < 3) {
                        selectedValues[idx] = value;
                        return;
                      }
                    }

                    for (let i = 0; i < 3; i++) {
                      if (!selectedValues[i]) {
                        selectedValues[i] = value;
                        break;
                      }
                    }
                  });

                for (const idx of requiredOptionIdxs) {
                  if (!selectedValues[idx]) return null;
                }

                const normalize = (str) =>
                  (str || "").toString().trim().toLowerCase();

                const matchingVariant = variants.find((v) => {
                  if (
                    selectedValues[0] &&
                    normalize(v.option1) !== normalize(selectedValues[0])
                  )
                    return false;
                  if (
                    selectedValues[1] &&
                    normalize(v.option2) !== normalize(selectedValues[1])
                  )
                    return false;
                  if (
                    selectedValues[2] &&
                    normalize(v.option3) !== normalize(selectedValues[2])
                  )
                    return false;
                  return true;
                });

                return matchingVariant ? matchingVariant.id.toString() : null;
              } catch (e) {
                return null;
              }
            }

            const optionGroupCount = new Set(
              getMainPdpSwatchInputs(productMainEl)
                .map((input) => input.getAttribute("optionIndex"))
                .filter(Boolean)
            ).size;

            const clickedVarId = $(this).attr("var_id");
            const combinedVarId = getSelectedVariantIdFromOptions();

            let var_id =
              (optionGroupCount <= 1
                ? clickedVarId || combinedVarId
                : combinedVarId || clickedVarId) ||
              (document.querySelector(
                ".pdp-cart-form .add-to-cart-form [name=\"id\"]"
              )?.value ||
                document.querySelector("#product-form-atc [name=\"id\"]")
                  ?.value ||
                document.querySelector("#product-form-atc-ctm [name=\"id\"]")
                  ?.value ||
                document.querySelector(
                  ".product-main .pdp-cart-form form [name=\"id\"]"
                )?.value);

            if (!isValidVariantId(var_id)) {
              if (mainVariantInput) {
                setTimeout(() => {
                  const finalVarId = mainVariantInput.value;
                  if (!isValidVariantId(finalVarId)) return;
                  applyPdpVariantChange(finalVarId);
                }, 150);
              }
              return;
            }

            applyPdpVariantChange(var_id);
          }
        );
    }

  function pdpTab() {

    $(".pdp-tabs-title").click(function () {
      var $title = $(this);
      var $tabBlock = $title.closest(".pdp-tab-block");
      var $content = $title.siblings(".pdp-tabs-content");

      $title.toggleClass("active");

      $content.slideToggle(function () {
        var contentElement = $content[0];
        if (contentElement) {
          contentElement.style.removeProperty("max-height");
          contentElement.style.removeProperty("overflow");
        }
        $tabBlock.find(".see-more-btn").remove();
      });
    });

    function initVisibleTabsPartialOpen() {
      var $allTabs = $(".pdp-tab-block");
      if ($allTabs.length === 0) return;

      var lastIndex = $allTabs.length - 1;

      $allTabs.each(function (index) {
        var $tabBlock = $(this);
        var $content = $tabBlock.find(".pdp-tabs-content");
        var $title = $tabBlock.find(".pdp-tabs-title");
        var contentElement = $content[0];

        // Keep first accordion closed; only last tab stays open by default
        if (index === lastIndex && index !== 0) {
          $title.addClass("active");
          $content.show();
        } else {
          $title.removeClass("active");
          $content.hide();
        }

        if (contentElement) {
          contentElement.style.removeProperty("max-height");
          contentElement.style.removeProperty("overflow");
        }
        $tabBlock.find(".see-more-btn").remove();
      });
    }

    setTimeout(function() {
      initVisibleTabsPartialOpen();
    }, 100);
  }


    function pdpImageSlider() {
      if (!$("#aniimated-thumbnials").length) {
        return;
      }
      $("#aniimated-thumbnials").lightGallery({
         selector: 'a',
        thumbnail: true,
        subHtmlSelectorRelative: false,
        getCaptionFromTitleOrAlt: false,
        autoplay: false,
        download: false,
        zoom: false,
        fullScreen: false,
        share: false,
        counter: false,
        videojs: false,
        youtubePlayerParams: {
          modestbranding: 1,
          showinfo: 0,
          rel: 0,
          controls: 1
        },
        vimeoPlayerParams: {
          byline : 0,
          portrait : 0,
          color : 'A90707'
        }
      });
      $('#aniimated-thumbnials').on('onAfterOpen.lg', function () {
          $('.lg-autoplay-button').remove();
      });

    $(document).ready(function () {
      $(".media-video-featured").each(function () {

        var $wrapper = $(this);
        var $video = $wrapper.find("video");
        var $button = $wrapper.find(".video-play-btn");
        var $preview = $wrapper.find(".media-preview-image");

        if (!$video.length || !$button.length) return;

        var vid = $video[0];

        var playIcon = $button.html();

        var pauseIcon = `
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 5h4v14H6zm8 0h4v14h-4z"/>
          </svg>
        `;

        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        $button.on("click", function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();

          $("video").each(function () {
            if (this !== vid) {
              this.pause();
              this.currentTime = 0;
            }
          });

          if (vid.paused) {

            if (!isMobile) {
              if (vid.requestFullscreen) vid.requestFullscreen();
              else if (vid.webkitRequestFullscreen) vid.webkitRequestFullscreen();
              else if (vid.msRequestFullscreen) vid.msRequestFullscreen();
            }

            vid.play();

          } else {
            vid.pause();
          }
        });

        
        $video.on("play", function () {
          $wrapper.addClass("played-video");
          $preview.hide();
          $button.html(pauseIcon);
        });

       
        $video.on("pause ended", function () {
          $wrapper.removeClass("played-video");
          $preview.show();
          $button.html(playIcon); 
        });
    });



  $('.product__main-carousel').on('beforeChange', function () {
    $("video").each(function () {
      this.pause();
      this.currentTime = 0;
    });
  });



  $(document).on(
    "fullscreenchange webkitfullscreenchange msfullscreenchange",
    function () {
      if (
        !document.fullscreenElement &&
        !document.webkitFullscreenElement &&
        !document.msFullscreenElement
      ) {
        $("video").each(function () {
          this.pause();
        });
      }
    }
  );

});

     var $carousel = $(".slider-for");
      $carousel.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        infinite: false,
        asNavFor: ".slider-nav",
        adaptiveHeight: true,
        draggable: true,
        swipe: true,
        touchMove: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              dots: false,
              fade: true,
              swipe: true,
              touchMove: true,
              draggable: true
            }
          }
        ]
      });
      $(".slider-nav").slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: ".slider-for",
        dots: false,
        infinite: false,
        focusOnSelect: true,
        draggable: true,
        swipe: true,
        touchMove: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              draggable: true,
              swipe: true,
              touchMove: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              draggable: true,
              swipe: true,
              touchMove: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              draggable: true,
              swipe: true,
              touchMove: true,
            },
          },
        ],
      });
    }
  }
  function initStickyATCWrapper() {
    const stickyAtc = document.getElementById("stickyAtcWrapper");
    const originalAtc = document.querySelector("#originalAtcWrapper button[type='submit']");
    const productForm = document.getElementById("product-form-atc");
    const stickyBtn = document.querySelector(".sticky-atc-btn");

    if (stickyAtc && originalAtc && stickyBtn && productForm) {
      if (window.stickyATCObserver) {
        window.stickyATCObserver.disconnect();
      }

      window.stickyATCObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              stickyAtc.classList.remove("show");
            } else {
              stickyAtc.classList.add("show");
            }
          });
        },
        { threshold: 0.1 }
      );
      window.stickyATCObserver.observe(originalAtc);

      const newStickyBtn = stickyBtn.cloneNode(true);
      stickyBtn.parentNode.replaceChild(newStickyBtn, stickyBtn);
      
      newStickyBtn.addEventListener("click", function() {
        productForm.requestSubmit();
      });
    }
  }

  function updateStickyATCPrice() {
    if (window.productJson) {
      try {
        const productForm = $(".pdp-cart-form form, form.add-to-cart-form, form[id*='product-form']").first();
        let variantId = null;
        
        if (productForm.length > 0) {
          const variantInput = productForm.find('input[name="id"]');
          if (variantInput.length > 0 && variantInput.val()) {
            variantId = variantInput.val();
          }
        }
        
        if (!variantId) {
          const stickyForm = $("#bottom-sticky-cta-section form");
          if (stickyForm.length > 0) {
            const stickyVariantInput = stickyForm.find('input[name="id"]');
            if (stickyVariantInput.length > 0 && stickyVariantInput.val()) {
              variantId = stickyVariantInput.val();
            }
          }
        }
        
        if (!variantId) {
          const selectedOptions = {};
          $('.tt-options-swatch input[type="radio"]:checked').each(function() {
            if ($(this).closest('[data-bogo-pair-options]').length) return;
            const optionName = $(this).attr('name');
            const optionValue = $(this).val();
            const optionIndex = $(this).attr('optionIndex');
            if (optionIndex) {
              selectedOptions[optionIndex] = optionValue;
            }
          });
          
          if (Object.keys(selectedOptions).length > 0) {
            const variantsJSON = JSON.parse(window.productJson);
            const matchingVariant = $.grep(variantsJSON, function (variant) {
              return $.map(selectedOptions, function (value, optionName) {
                return variant[optionName] === value;
              }).every(Boolean);
            })[0];
            
            if (matchingVariant) {
              variantId = matchingVariant.id;
            }
          }
        }
        
        if (!variantId) {
          const stickySelectedOptions = {};
          $("#bottom-sticky-cta-section .select__select").each(function() {
            const optionIndex = $(this).attr('optionIndex');
            const selectedValue = $(this).val();
            if (optionIndex && selectedValue) {
              stickySelectedOptions[optionIndex] = selectedValue;
            }
          });
          
          if (Object.keys(stickySelectedOptions).length > 0) {
            const variantsJSON = JSON.parse(window.productJson);
            const matchingVariant = $.grep(variantsJSON, function (variant) {
              return $.map(stickySelectedOptions, function (value, optionName) {
                return variant[optionName] === value;
              }).every(Boolean);
            })[0];
            
            if (matchingVariant) {
              variantId = matchingVariant.id;
            }
          }
        }
        
        if (variantId && window.productJson) {
          const variantsJSON = JSON.parse(window.productJson);
          const variant = variantsJSON.find(function(v) {
            return v.id == variantId || v.id.toString() === variantId.toString();
          });
          
          if (variant) {
            const price = getItemFormatedPrice(variant.price);
            const comparePrice = variant.compare_at_price && variant.compare_at_price > variant.price 
              ? getItemFormatedPrice(variant.compare_at_price) 
              : null;
            
            if ($("#bottom-sticky-cta-section").length > 0) {
              const priceElement = $("#bottom-sticky-cta-section .fixed-product-price, #sticky-atc-price");
              if (priceElement.length > 0) {
                const priceCurrent = $("#sticky-atc-price-current");
                const priceCompare = $("#sticky-atc-price-compare");
                
                if (priceCurrent.length > 0) {
                  priceCurrent.text(price);
                  
                  if (comparePrice && priceCompare.length > 0) {
                    priceCompare.text(comparePrice);
                    priceCompare.show();
                  } else if (priceCompare.length > 0) {
                    priceCompare.hide();
                  } else if (comparePrice) {
                    priceCurrent.after(' <del id="sticky-atc-price-compare">' + comparePrice + '</del>');
                  }
                } else {
                  if (comparePrice) {
                    priceElement.html('<span id="sticky-atc-price-current">' + price + '</span> <del id="sticky-atc-price-compare">' + comparePrice + '</del>');
                  } else {
                    priceElement.html('<span id="sticky-atc-price-current">' + price + '</span>');
                  }
                }
                
                const stickyForm = $("#bottom-sticky-cta-section form");
                if (stickyForm.length > 0) {
                  let stickyVariantInput = stickyForm.find('input[name="id"]');
                  if (stickyVariantInput.length === 0) {
                    stickyForm.append('<input type="hidden" name="id" value="' + variant.id + '">');
                  } else {
                    stickyVariantInput.val(variant.id);
                  }
                }
              }
            }
            
            if ($("#stickyAtcWrapper").length > 0) {
              const priceCurrent = $("#stickyAtcWrapper #product-price-current");
              const priceCompare = $("#stickyAtcWrapper #product-price-compare");
              
              if (priceCurrent.length > 0) {
                priceCurrent.text(price);
                
                if (comparePrice && priceCompare.length > 0) {
                  priceCompare.text(comparePrice);
                  priceCompare.show();
                } else if (priceCompare.length > 0) {
                  priceCompare.hide();
                }
              }
            }
          }
        }
      } catch (error) {
        console.warn("Error updating sticky ATC price:", error);
      }
    }
  }

  function stickyATC() {
    if ($("#bottom-sticky-cta-section").length > 0) {
      $("#bottom-sticky-cta-section .select__select").change(async function () {
        let selectedOptions = {};
        let selectedValue = $(this).val();
        let optionIndex = $(this).attr("optionIndex");
        selectedOptions[optionIndex] = selectedValue;
        const variantsJSON = JSON.parse(window.productJson);
        const matchingVariant = $.grep(variantsJSON, function (variant) {
          return $.map(selectedOptions, function (value, optionName) {
            return variant[optionName] === value;
          }).every(Boolean);
        })[0];
        let urlObj = new URL(window.location.href);
        urlObj.searchParams.set("variant", matchingVariant.id);
        let newUrl = urlObj.toString();
        try {
          let response = await getAjax(newUrl, "GET", "html");
          const stickyATCLayout = $(response)
            .find("#bottom-sticky-cta-section")
            .html();
          $("#bottom-sticky-cta-section").html(stickyATCLayout);
          actionStickyATC();
          onStickyQtyChange();
          stickyATC();
          setTimeout(function() {
            updateStickyATCPrice();
          }, 200);
        } catch {}
      });
      const actualATC = $(".pdp-cart-form");
      const stickyATC = $("#bottom-sticky-cta-section");
      const top = actualATC.offset().top;

      const stickyATCscrollHandler = (event) => {
        const y = $(document).scrollTop();
        const windowHeight = $(window).height();
        const documentHeight = $(document).height();

        const recommendedProductsTab = $('.pdp-tabs-title.active');
        const isRecommendedProductsActive = recommendedProductsTab.length > 0 && 
          recommendedProductsTab.text().toLowerCase().includes('recommended') ||
          recommendedProductsTab.text().toLowerCase().includes('aanbevolen') ||
          recommendedProductsTab.text().toLowerCase().includes('vergelijkbaar');
        
        const recommendedProductsContent = $('.recommended-products-grid').closest('.pdp-tabs-content');
        const isRecommendedProductsVisible = recommendedProductsContent.length > 0 && 
          recommendedProductsContent.is(':visible') && 
          recommendedProductsContent.css('display') !== 'none';

        if (isRecommendedProductsActive || isRecommendedProductsVisible) {
          stickyATC.removeClass("sticky-atc");
          return;
        }

        if (y >= top && y + windowHeight < documentHeight) {
          stickyATC.addClass("sticky-atc");
        } else {
          stickyATC.removeClass("sticky-atc");
        }
      };

      $(window).on("scroll", stickyATCscrollHandler);
    }
  }

  function onStickyQtyChange() {
    if ($(".sticky-qty-wrapper .sticky-qty-btn").length > 0) {
      $(".sticky-qty-wrapper .sticky-qty-btn").click(async function () {
        const inputQty = $(this).parent().find("input.sticky-qty-input_box");
        const currentQty = parseInt(inputQty.val());

        if ($(this).hasClass("plus-btn")) {
          inputQty.val(Math.max(currentQty + 1, 1));
        } else {
          inputQty.val(Math.max(currentQty - 1, 1));
        }
      });
    }
  }

  function actionStickyATC() {
    if ($("#bottom-sticky-cta-section").length > 0) {
      $("#bottom-sticky-cta-section .sticky-atc-form")
        .off("submit.stickyAtc")
        .on("submit.stickyAtc", async function (event) {
          event.preventDefault();
          event.stopPropagation();

          const $form = $(this);
          // Same 2+1 selections as the main product form.
          if (document.querySelector("[data-bogo-2-plus-1-options]")) {
            event.stopImmediatePropagation();
            await addBogo2Plus1ToCart($form);
            return;
          }

          // R2B custom bundle: the bottom sticky form used to serialize only
          // itself, which dropped the selected bundle add-ons. Route it through
          // the same PDP bundle handler as the normal add-to-cart button.
          const hasR2bBundle =
            Array.isArray(window.bundleSelectedProducts) &&
            window.bundleSelectedProducts.length > 0;

          if (hasR2bBundle && typeof window.r2bSubmitWithBundle === "function") {
            event.stopImmediatePropagation();
            const $mainForm = getMainPdpAtcForm$();
            const mainForm = $mainForm && $mainForm.length ? $mainForm.get(0) : null;
            const triggerBtn =
              $form.find('button[type="submit"]').get(0) ||
              document.querySelector(".sticky-atc-btn") ||
              document.querySelector("#originalAtcWrapper button[type='submit']");

            if (mainForm) {
              window.r2bSubmitWithBundle(mainForm, triggerBtn);
              return;
            }
          }

          if ($form.data("atc-busy") || !beginAddToCart($form)) return;

          try {
            if (!isCartDrawerMode()) {
              loading(true);
            }
            const addQty = getFormAddQuantity($form);
            const response = await postAjax(
              "/cart/add.js",
              "POST",
              "json",
              $form.serialize()
            );
            const itemImageUrl =
              response.featured_image && response.featured_image.url
                ? response.featured_image.url
                : "";
            const itemTitle = response.title;
            const itemQty = addQty;
            const itemTotalPrice = getItemFormatedPrice(
              response.price * itemQty
            );
            const cartQty = parseInt(window.cart.quantity, 10) + addQty;
            const cartTotalPriceWithoutFormatedPrice =
              parseInt(window.cart.total_price, 10) +
              parseInt(response.price, 10) * addQty;
            const cartTotalPrice = getItemFormatedPrice(
              cartTotalPriceWithoutFormatedPrice
            );
            await showAfterAddToCart({
              itemImageUrl,
              itemTitle,
              itemQty,
              itemTotalPrice,
              cartQty,
              cartTotalPrice,
              cartTotalPriceWithoutFormatedPrice,
            });
          } catch (error) {
            console.error("Sticky ATC add to cart:", error);
            loading(false);
          } finally {
            endAddToCart($form);
          }
        });
    }
  }
  function addToCartFormRecommandation() {
    $(document)
      .off("submit.r2bRec", ".product-recommendations .add-to-cart-form")
      .on(
        "submit.r2bRec",
        ".product-recommendations .add-to-cart-form",
        async function (event) {
          event.preventDefault();
          event.stopPropagation();

          const $form = $(this);
          if ($form.data("atc-busy") || !beginAddToCart($form)) return;

          try {
            try {
              const resolvedVariantId = resolveSelectedVariantId(this);
              if (resolvedVariantId) {
                $form.find('input[name="id"]').val(resolvedVariantId);
              }
            } catch (e) {}

            if (!isCartDrawerMode()) {
              loading(true);
            }
            const addQty = getFormAddQuantity($form);
            const response = await postAjax(
              "/cart/add.js",
              "POST",
              "json",
              $form.serialize()
            );
            const itemImageUrl =
              response.featured_image && response.featured_image.url
                ? response.featured_image.url
                : "";
            const itemTitle = response.title;
            const itemQty = addQty;
            const itemTotalPrice = getItemFormatedPrice(
              response.price * itemQty
            );
            const cartQty = parseInt(window.cart.quantity, 10) + addQty;
            const cartTotalPriceWithoutFormatedPrice =
              parseInt(window.cart.total_price, 10) +
              parseInt(response.price, 10) * addQty;
            const cartTotalPrice = getItemFormatedPrice(
              cartTotalPriceWithoutFormatedPrice
            );
            await showAfterAddToCart({
              itemImageUrl,
              itemTitle,
              itemQty,
              itemTotalPrice,
              cartQty,
              cartTotalPrice,
              cartTotalPriceWithoutFormatedPrice,
            });
          } catch (error) {
            console.error("Error loading more content:", error);
            loading(false);
          } finally {
            endAddToCart($form);
          }
        }
      );
  }
  function pdpJS() {
    bindSwatchLabelClickFallback();
    syncCheckedAttributeForSwatches();
    onChangeVariant();
    pdpTab();
    pdpImageSlider();
    stickyATC();
    actionStickyATC();
    onStickyQtyChange();

    function getMainPdpAtcForm$() {
      const $a = $("#product-form-atc");
      if ($a.length) return $a;
      const $b = $("#product-form-atc-ctm");
      if ($b.length) return $b;
      return $(".product-main .pdp-cart-form form").first();
    }

    $(window).off('variant:change.stickyATC').on('variant:change.stickyATC', function() {
      setTimeout(function() {
        updateStickyATCPrice();
        syncStickyFormVariant();
      }, 100);
    });
    getMainPdpAtcForm$()
      .off('change.stickyATC')
      .on('change.stickyATC', 'input[name="id"]', function() {
      setTimeout(function() {
        updateStickyATCPrice();
        syncStickyFormVariant();
      }, 100);
    });
    
    function syncStickyFormVariant() {
      const mainForm = getMainPdpAtcForm$();
      const stickyForm = $("#bottom-sticky-cta-section form");
      
      if (mainForm.length > 0 && stickyForm.length > 0) {
        const mainVariantInput = mainForm.find('input[name="id"]');
        const stickyVariantInput = stickyForm.find('input[name="id"]');
        
        if (mainVariantInput.length > 0 && mainVariantInput.val()) {
          if (stickyVariantInput.length === 0) {
            stickyForm.append('<input type="hidden" name="id" value="' + mainVariantInput.val() + '">');
          } else {
            stickyVariantInput.val(mainVariantInput.val());
          }
        }
      }
    }
    
    if (typeof MutationObserver !== 'undefined') {
      const mainForm = getMainPdpAtcForm$();
      if (mainForm.length > 0) {
        const variantInput = mainForm.find('input[name="id"]')[0];
        if (variantInput) {
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                setTimeout(function() {
                  updateStickyATCPrice();
                  syncStickyFormVariant();
                }, 100);
              }
            });
          });
          observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        }
      }
    }
    
    updateStickyATCPrice();
    syncStickyFormVariant();
    if(typeof Globo != 'undefined' && typeof Globo?.Preorder != 'undefined') Globo?.Preorder?.initPreorder()
    addToCartFormRecommandation();
    setTimeout(function () {
      updateStickyATCPrice();
    }, 2000);
  }

  function loading(bool) {
    if (bool) {
      $("#r2b-loader").show();
      $("html").addClass("rt-loading");
    } else {
      $("#r2b-loader").hide();
      $("html").removeClass("rt-loading");
    }
  }

  function getItemFormatedPrice(price) {
    const currencies_using_comma_decimals =
      "ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,UYU,VES,VND";
    let formattedPrice;
    if (
      currencies_using_comma_decimals.includes(window.shop.currencyCode.trim())
    ) {
      formattedPrice = (price / 100).toFixed(2).replace(".", ",");
    } else {
      formattedPrice = (price / 100).toFixed(2);
    }
    return window.shop.currencySymbol + formattedPrice;
  }

  /* R2B: helpers beschikbaar maken voor PDP add-to-cart zonder redirect. */
  if (typeof softRefreshCartDrawer === 'function') {
    window.r2bRefreshCartDrawer = async function (openAfter) {
      await softRefreshCartDrawer(!!openAfter, { preserveItems: false });
    };
  }
  window.r2bOpenCartDrawer = function () {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-active');
  };

});